<template>
  <div>
    <b-toast
      id="toast-check-modal-request-class-nav-student"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-check.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-modal-request-class-nav-student"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-check-modal-calendar-class-edit"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-check.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-modal-calendar-class-edit"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-check-modal-request-class"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-check.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-modal-request-class"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-modal
      :hide-footer="true"
      :hide-header="true"
      :centered="true"
      modal-class="modal-schedule"
      id="modal-schedule"
      size="xl"
      @hide="handleHideModal"
    >
      <div v-if="showEditSchedule">
        <div class="ea-alert mt-4" v-if="!isResponseReceived">
          <icon name="alert-2" />
          <div class="content">
            <p class="bold">
              {{ $t("reusables.student-edited-schedule") }}
            </p>
          </div>
        </div>
        <div class="ea-alert px-4 mb-0" v-show="showEditSchedule" v-else>
          <icon name="alert-2" />
          <div class="content">
            <p class="bold">{{ $t("reusables.student-edited-schedule-6") }}</p>
            <div
              class="d-flex justify-content-center"
              style="gap: 5rem"
              v-if="!flagPlanTest"
            >
              <div class="text-left">
                <p class="bold">
                  {{ $t("reusables.student-edited-recurring-schedule") }}:
                </p>
                <ul class="mb-0" v-if="listRecurrent.length > 0">
                  <li v-for="item in listRecurrent" :key="item.start">
                    {{ item.date }}
                  </li>
                </ul>
                <p class="mb-0" v-else></p>
              </div>
              <div class="text-left">
                <p class="bold">
                  {{ $t("reusables.student-edited-add-classes") }}:
                </p>
                <ul
                  class="mb-0"
                  v-if="
                    calendarOptions.events.filter((currentValue) => {
                      return currentValue.noRecurrent == true;
                    }).length > 0
                  "
                >
                  <li
                    v-for="item in calendarOptions.events.filter(
                      (currentValue) => {
                        return currentValue.noRecurrent == true;
                      }
                    )"
                    :key="item.start"
                  >
                    {{ getFormatDateCompleteTitle(item.start, item.end) }}
                  </li>
                </ul>
                <p class="mb-0" v-else></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <template #modal-header="{ $bvModal }"> -->
      <img
        class="close"
        src="@/assets/img/close_red.png"
        @click="modalHideSchedule"
      />

      <!-- </template> -->
      <b-row>
        <div style="width: 100%" v-if="showEditStudent"></div>
        <div class="w-100 d-flex" v-else>
          <b-col class="text availability">
            <div class="content-changue">
              <p v-if="!dataTeacher.flagEnviado">
                <a href="#" class="bold" @click="showModalAndDate">{{
                  $t("modals.modalViewSchedule.else.button")
                }}</a>
                <!-- <span v-else>{{$t('modals.modalViewSchedule.else.button')}}</span>-->
                {{ $t("modals.modalViewSchedule.else.text.1") }}
                {{ dataTeacher.person ? dataTeacher.person.firstName : "" }}
              </p>
              <p v-else>
                {{ $t("modals.modalViewSchedule.else.text.2") }}
                {{ dataTeacher.person ? dataTeacher.person.firstName : "" }}
              </p>
            </div>
          </b-col>
        </div>
      </b-row>
      <!------------------------modal ----------------------------->
      <div>
        <b-modal
          id="modal-schedule-acept" 
          :hide-footer="false"
          :hide-header="false"
          :hide-body="true"
          :centered="true"
          :no-close-on-esc="true"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="
                close();
                showButtonAccept = true;
              "
            />
            <p class="text-center">
              Are you sure you would like to apply to teach
              {{ dataStudent.className }}?
            </p>
          </template>
          <div>
            <b-alert
              show
              variant="danger"
              style="padding: 5px; font-size: 0.95rem; text-align: center"
              v-if="crossingSchedule > 0"
            >
              {{ nameWarning }}
            </b-alert>
          </div>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="
                $bvModal.hide('modal-schedule-acept'), (crossingSchedule = 0);
                showButtonAccept = true;
              "
              >{{
                $t(
                  "modals.modalViewSchedule.modal-schedule-cancel.button-cancel"
                )
              }}</b-button
            >
            <b-button
              v-if="showButtonAccept"
              @click="acceptCounterProposal"
              variant="primary"
            >
              <template v-if="!showSpinnerAccept">{{
                $t("modals.modalViewSchedule.modal-schedule.text-acept")
              }}</template>
              <b-spinner
                style="width: 1rem !important; height: 1rem !important"
                v-else
                variant="light"
                label="Spinning"
              ></b-spinner>
            </b-button>
          </template>
        </b-modal>
      </div>
      <div>
        <b-modal
          id="modal-schedule-accept-nav-student"
          style="flex-direction: column"
          :centered="true"
          no-close-on-backdrop
          :no-close-on-esc="true"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
          </template>
          <p class="text-center mb-0">
            {{ $t("reusables.student-edited-schedule-8") }}
          </p>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="$bvModal.hide('modal-schedule-accept-nav-student')"
              >{{
                $t("modals.modalViewSchedule.modal-schedule.button-cancel")
              }}</b-button
            >
            <b-button
              variant="primary"
              @click="acceptProposal"
              :class="{ loading: showSpinnerAccept }"
            >
              <template v-if="!showSpinnerAccept">{{
                $t("modals.modalViewSchedule.modal-schedule.text-acept")
              }}</template>
              <b-spinner
                style="width: 1rem !important; height: 1rem !important"
                v-else
                variant="light"
                label="Spinning"
              ></b-spinner>
            </b-button>
          </template>
        </b-modal>
      </div>

      <div>
        <b-modal
          id="modal-schedule-reject"
          style="flex-direction: column"
          :centered="true"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <h5 style="text-align: center">
              {{
                `${$t(
                  "modals.modalViewSchedule.modal-schedule-reject.sub-titulo-2"
                )} ${dataStudent.className} ${$t(
                  "modals.modalViewSchedule.modal-schedule-reject.sub-titulo-3"
                )}`
              }}
            </h5>
          </template>
          <div>
            <b-form-group id="fieldset-1" class="w-100">
              <b-form-textarea
                v-model.trim="proposal.commentary"
                no-resize
                :placeholder="
                  $t('modals.modalViewSchedule.modal-schedule-reject.motive')
                "
                rows="3"
                autofocus
                required
                v-bind:class="{ error: $v.proposal.commentary.$error }"
                @blur="$v.proposal.commentary.$touch()"
              >
              </b-form-textarea>
              <span class="error-input">{{
                validationMsgCommetary($v.proposal.commentary)
              }}</span>
            </b-form-group>
          </div>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="
                $bvModal.hide('modal-schedule-reject'), (crossingSchedule = 0)
              "
              >{{
                $t(
                  "modals.modalViewSchedule.modal-schedule-reject.button-cancel"
                )
              }}</b-button
            >
            <b-button
              variant="primary"
              :disabled="$v.proposal.commentary.$invalid"
              @click="rejectCounterProposal"
              :class="{ loading: showSpinnerReject }"
            >
              {{ $t("modals.modalViewSchedule.modal-schedule.text-acept") }}
            </b-button>
          </template>
        </b-modal>
      </div>

      <div>
        <b-modal
          id="modal-schedule-send"
          :centered="true"
          :no-close-on-esc="true"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
          </template>
          <p class="text-center mb-0" v-if="!flagCancelEdit">
            {{
              flagDeleteEvent || arraySchedulePrivate.length > 0
                ? $t("modals.modalViewSchedule.modal-schedule-send.text.1")
                : "Are you sure you would like to apply to teach"
            }}
            {{ dataStudent.className }}?
          </p>
          <p class="text-center mb-0" v-else>
            {{ $t("modals.modalViewSchedule.modal-schedule-resend.titleEdit") }}
          </p>
          <b-alert
            show
            variant="danger"
            style="padding: 5px; font-size: 0.95rem; text-align: center"
            v-if="crossingSchedule > 0"
            >{{ nameWarning }}</b-alert
          >
          <!--{{$t('modals.modalViewSchedule.modal-schedule-send.alert')}}-->
          <template #modal-footer>
            <div class="w-100 d-flex justify-content-center">
              <b-button
                variant="danger"
                class="mr-2"
                @click="
                  $bvModal.hide('modal-schedule-send');
                  crossingSchedule = 0;
                "
                >{{
                  $t(
                    "modals.modalViewSchedule.modal-schedule-send.button-cancel"
                  )
                }}</b-button
              >
              <b-button
                @click="sendCounterProposal"
                variant="primary"
                :class="{ loading: showSpinnerSend }"
              >
                {{
                  $t("modals.modalViewSchedule.modal-schedule-send.buttonSend")
                }}
              </b-button>
            </div>
          </template>
        </b-modal>
      </div>
      <div>
        <b-modal
          id="modal-schedule-reject-nav-student"
          style="flex-direction: column"
          :centered="true"
          no-close-on-backdrop
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
          </template>
          <p class="text-center mb-0">
            {{ $t("reusables.student-edited-schedule-10") }}
          </p>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="$bvModal.hide('modal-schedule-reject-nav-student')"
              >{{
                $t(
                  "modals.modalViewSchedule.modal-schedule-reject.button-cancel"
                )
              }}</b-button
            >
            <b-button
              variant="primary"
              @click="rejectProposal"
              :class="{ loading: showSpinnerReject }"
            >
              <template v-if="!showSpinnerReject">{{
                $t("modals.modalViewSchedule.modal-schedule.text-rejectIt")
              }}</template>
              <b-spinner
                style="width: 1rem !important; height: 1rem !important"
                v-else
                variant="light"
                label="Spinning"
              ></b-spinner>
            </b-button>
          </template>
        </b-modal>
      </div>
      <div>
        <b-modal
          id="modal-schedule-cancel"
          :centered="true"
          :no-close-on-esc="true"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
          </template>
          <p class="text-center mb-0" v-if="!flagCancelEdit">
            {{ $t("modals.modalViewSchedule.modal-schedule-cancel.titulo") }}
          </p>
          <p class="text-center mb-0" v-else>
            {{ $t("modals.modalViewSchedule.modal-schedule-cancel.titulo-2") }}
          </p>
          <template #modal-footer>
            <div class="w-100 d-flex justify-content-center">
              <b-button
                variant="danger"
                class="mr-2"
                @click="$bvModal.hide('modal-schedule-cancel')"
                >{{
                  $t(
                    "modals.modalViewSchedule.modal-schedule-cancel.button-cancel"
                  )
                }}</b-button
              >
              <b-button
                @click="cancelCounterProposal"
                variant="primary"
                :class="{ loading: showSpinnerCancel }"
              >
                <template v-if="!showSpinnerCancel">{{
                  $t("modals.modalViewSchedule.modal-schedule-cancel.button")
                }}</template>
                <b-spinner
                  style="width: 1rem !important; height: 1rem !important"
                  v-else
                  variant="light"
                  label="Spinning"
                ></b-spinner>
              </b-button>
            </div>
          </template>
        </b-modal>
      </div>
      <!------------------------ fin - modal ----------------------------->
      <div class="calendar" style="position: relative">
        <!-- <div class="content-changue" v-if="!disabledDate">
          <b-alert show variant="warning">{{
            $t("modals.modalViewSchedule.text.8")
          }}</b-alert>
        </div> -->
        <div v-if="showLoading" class="container-loading">
          <b-spinner :label="$t('reusables.loading')"></b-spinner>
        </div>
        <div v-else>
          <div
            class="body-header edit"
            :style= "[!flagShowHeader ? 
              {'position': 'absolute',
                'left': '0',
                'width': '130px',
                'z-index': '10'
              } : 
              {
                'position': 'absolute',
                'left': '200px',
                'width': '130px',
                'z-index': '10'
              }]"
          >
            <CustomSelect
              v-if="optionsTime.length > 0"
              style="width: 150px"
              class="mb-3"
              @input="idValueSelectEventSelectedTime"
              :options="optionsTime"
              value="value"
              label="text"
              :default="null"
              :defaultValue="this.selectedTime"
              :isActiveMethodValidOpcion="true"
              @change="getWeek()"
            />
          </div>
          <div
            class="d-flex justify-content-end"
            style="position: absolute; right: 0"
            :style= "[!flagShowHeader ? 
              {'position': 'relative'} : 
              {
                'position': 'absolute',
                'right': '0px',
                'z-index': '10'
              }]"
            v-if="showEditStudent"
          >
            <b-button
              variant="primary"
              v-if="showEditSchedule && isResponseReceived"
              class="btn-gris"
              v-b-modal.modal-schedule-accept-nav-student
              >{{ $t("modals.modalViewSchedule.button-acept") }}</b-button
            >
            <b-button
              variant="outline-primary"
              class="ml-2"
              v-if="showEditSchedule"
              @click="editCalendarCounterProposal"
              :style="'position: relative;bottom: ' + `${0}` + ' ;z-index:10'"
              ><icon name="edit-pencil" />{{ $t("reusables.edit") }}</b-button
            >
            <!--  -->
            <b-button
              variant="danger"
              class="ml-2"
              @click="reply"
              v-if="!showEditSchedule"
              ><icon name="undo" />{{ $t("horario.reply.text") }}</b-button
            >
            <b-button
              variant="outline-primary"
              :disabled="disabledButton"
              @click="showModalEditarHorario"
              v-if="!showEditSchedule"
              class="btn-outline ml-2"
              ><icon name="edit-pencil" />{{
                $t("horario.next-class.save-changes")
              }}
            </b-button>
            <b-button
              variant="primary"
              class="btn-gris ml-2"
              v-if="showEditSchedule && !isResponseReceived"
              @click="$bvModal.show('modal-schedule-send')"
              >{{ $t("modals.modalViewSchedule.button-resend") }}</b-button
            >
            <b-button
              variant="danger"
              class="ml-2"
              v-if="showEditSchedule && !isResponseReceived"
              v-b-modal.modal-schedule-cancel
              >{{ $t("modals.modalViewSchedule.button-cancel") }}</b-button
            >
            <b-button
              variant="danger"
              class="ml-2"
              v-if="showEditSchedule && isResponseReceived"
              @click="$bvModal.show('modal-schedule-reject-nav-student')"
              >{{ $t("modals.modalViewSchedule.button-reject") }}</b-button
            >
          </div>
          <FullCalendar
            class="demo-app-calendar"
            :class="!showEditSchedule ? 'editCalendar' : ''"
            :options="calendarOptions"
            ref="fullCalendar"
          >
            <template v-slot:eventContent="arg">
              <div class="fc-event-main-frame" :class="arg.event.className">
                <!--!dataStudent.flagPlanTest &&-->
                <span
                  v-if="
                    arg.event.startEditable && isFutureEvent(arg.event.start)
                  "
                  @click="removeEvent(arg.event)"
                  style="cursor: pointer"
                  class="material-icons"
                  >clear</span
                >
                <div class="fc-event-time">{{ arg.timeText }}</div>
                <div class="fc-event-title-container">
                  {{ arg.event.title }}
                </div>
              </div>
            </template>
          </FullCalendar>
        </div>
        <div class="content-loader" v-show="flagCancelClass">
          <div class="loader"></div>
        </div>
        <!--MODAL ELIMINAR CLASE RECURRENTE-->
        <b-modal
          id="delete-recurring-class-edit"
          :centered="true"
          body-class="pt-2"
          footer-class="justify-content-center"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <h4 class="bold text-center">
              {{
                $t("reusables.student-edited-delete-recurrent-classes-title")
              }}
            </h4>
          </template>
          <div style="font-size: 15px">
            <div class="mx-auto" style="max-width: 300px">
              <p class="d-flex align-items-center mb-2">
                <icon name="calendar" class="mr-2 icon-blue-dark" />
                {{
                  infoEventoDelete.startDate != null &&
                  infoEventoDelete.endDate != null
                    ? getFormatDateCompleteClass(
                        infoEventoDelete.startDate,
                        infoEventoDelete.endDate
                      )
                    : ""
                }}
              </p>
              <p class="d-flex align-items-center mb-2">
                <icon name="time" class="mr-2 icon-blue-dark" />
                {{
                  infoEventoDelete.startDate != null &&
                  infoEventoDelete.endDate != null
                    ? getFormatDateCompleteTitleTime(
                        infoEventoDelete.startDate,
                        infoEventoDelete.endDate
                      )
                    : ""
                }}
              </p>
            </div>
            <div class="mx-auto mt-4" style="max-width: 245px">
              <b-form-radio
                name="some-radios"
                value="true"
                v-model="classDelete.typeClass"
                >{{ $t("reusables.this-class") }}</b-form-radio
              >
              <b-form-radio
                name="some-radios"
                value="false"
                v-model="classDelete.typeClass"
                >{{ $t("reusables.this-class-following") }}</b-form-radio
              >
              <span class="error-input">{{
                validationForm($v.classDelete.typeClass)
              }}</span>
            </div>
          </div>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="$bvModal.hide('delete-recurring-class-edit')"
              >{{ $t("reusables.cancel") }}</b-button
            >
            <b-button variant="primary" @click="SaveClassDelete">
              <template v-if="!showSpinnerSend">{{
                $t("reusables.delete")
              }}</template>
            </b-button>
          </template>
        </b-modal>
        <!-- ------- -->
        <!--MODAL AGREGAR CLASE-->
        <b-modal
          id="modal-add-class-edit"
          :centered="true"
          body-class="pt-2"
          footer-class="justify-content-center"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <h4 class="bold text-center">
              {{ $t("reusables.student-edited-add-classes-title") }}
            </h4>
          </template>
          <div style="font-size: 15px">
            <div class="mx-auto" style="max-width: 300px">
              <p class="d-flex align-items-center mb-2">
                <icon name="calendar" class="mr-2 icon-blue-dark" />
                {{
                  this.eventCreated != null
                    ? getFormatDateCompleteClass(
                        this.eventCreated.startStr,
                        this.eventCreated.endStr
                      )
                    : ""
                }}
              </p>
              <p class="d-flex align-items-center mb-2">
                <icon name="time" class="mr-2 icon-blue-dark" />
                {{
                  this.eventCreated != null
                    ? getFormatDateCompleteTitleTime(
                        this.eventCreated.startStr,
                        this.eventCreated.endStr
                      )
                    : ""
                }}
              </p>
            </div>
            <div class="mx-auto mt-4" style="max-width: 245px">
              <b-form-radio
                name="some-radios"
                value="true"
                v-model.trim="classRegister.typeClass"
                >{{ $t("reusables.notRepeated") }}</b-form-radio
              >
              <b-form-radio
                name="some-radios"
                v-model.trim="classRegister.typeClass"
                value="false"
                >{{ $t("reusables.repeats-every-week") }}</b-form-radio
              >
              <span class="error-input">{{
                validationForm($v.classRegister.typeClass)
              }}</span>
            </div>
          </div>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="$bvModal.hide('modal-add-class-edit')"
              >{{ $t("reusables.cancel") }}</b-button
            >
            <b-button variant="primary" @click="SaveClassRegister">
              <template v-if="!showSpinnerSend">{{
                $t("reusables.class-add")
              }}</template>
            </b-button>
          </template>
        </b-modal>
        <!-- ------- -->

        <!--MODAL AGREGAR CLASE PLAN PRUEBA-->
        <b-modal
          id="modal-add-class-plan-test"
          :centered="true"
          :title="$t('title.11')"
          body-class="pt-2"
          footer-class="justify-content-center"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <h5>{{ $t("title.11") }}</h5>
          </template>
          <p class="d-flex align-items-center">
            <i class="material-icons-outlined mr-3">bookmark</i>
            <span>{{ $t("reusables.test-class") }}</span>
          </p>
          <p class="d-flex align-items-center">
            <span class="material-icons-outlined mr-3">schedule</span>
            <span>{{
              this.eventCreated != null
                ? getFormatDate(
                    this.eventCreated.startStr,
                    this.eventCreated.endStr,
                    this.lang,
                    flagPlanTest,
                    maximoHorasCalendario
                  )
                : ""
            }}</span>
          </p>
          <div>
            <b-alert
              show
              variant="danger"
              style="padding: 5px; font-size: 0.7rem; text-align: center"
              v-if="showAlertModal"
              >{{ message }}</b-alert
            >
          </div>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="$bvModal.hide('modal-add-class-plan-test')"
              >{{ $t("reusables.cancel") }}</b-button
            >
            <b-button variant="primary" @click="saveEvent">
              <template v-if="!showSpinnerSend">{{
                $t("reusables.class-add")
              }}</template>
            </b-button>
          </template>
        </b-modal>
        <!-- ------- -->

        <!--MODAL ELIMINAR CLASE-->
        <b-modal
          id="modal-delete-class-edit"
          :centered="true"
          body-class="pt-2"
          footer-class="justify-content-center"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <h4 class="bold text-center">
              {{ $t("reusables.student-edited-delete-classes-title") }}
            </h4>
          </template>
          <div style="font-size: 15px">
            <div class="mx-auto" style="max-width: 300px">
              <p class="d-flex align-items-center mb-2">
                <icon name="calendar" class="mr-2 icon-blue-dark" />
                {{
                  infoEventoDelete.startDate != null &&
                  infoEventoDelete.endDate != null
                    ? getFormatDateCompleteClass(
                        infoEventoDelete.startDate,
                        infoEventoDelete.endDate
                      )
                    : ""
                }}
              </p>
              <p class="d-flex align-items-center mb-2">
                <icon name="time" class="mr-2 icon-blue-dark" />
                {{
                  infoEventoDelete.startDate != null &&
                  infoEventoDelete.endDate != null
                    ? getFormatDateCompleteTitleTime(
                        infoEventoDelete.startDate,
                        infoEventoDelete.endDate
                      )
                    : ""
                }}
              </p>
            </div>
          </div>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="$bvModal.hide('modal-delete-class-edit')"
              >{{ $t("reusables.cancel") }}</b-button
            >
            <b-button variant="primary" @click="SaveClassDeleteNoRecurrent">
              <template v-if="!showSpinnerSend">{{
                $t("reusables.delete")
              }}</template>
              <!-- <b-spinner
                  style="width: 1rem !important; height: 1rem !important"
                  v-else
                  variant="light"
                  label="Spinning"
                ></b-spinner> -->
            </b-button>
          </template>
        </b-modal>
        <!-- ------- -->
        <!--MODAL ELIMINAR CLASE(SIN RESULTADO)-->
        <b-modal
          id="modal-delete-class-without-result-edit"
          :centered="true"
          body-class="pt-2"
          footer-class="justify-content-center"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <h4 class="bold text-center">
              {{ $t("reusables.student-edited-delete-classes-title") }}
            </h4>
          </template>
          <div style="font-size: 15px">
            <div class="mx-auto" style="max-width: 220px">
              <p class="d-flex align-items-center mb-">
                {{ $t("reusables.there-no-class-eliminate") }}
              </p>
            </div>
          </div>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="$bvModal.hide('modal-delete-class-without-result-edit')"
              >{{ $t("reusables.cancel") }}</b-button
            >
          </template>
        </b-modal>
        <!-- ------- -->
        <!--MODAL VALIDAR CLASE PARA AGREGAR-->
        <b-modal
          id="modal-validate-register-class-edit"
          :centered="true"
          body-class="pt-2"
          footer-class="justify-content-center"
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
          </template>
          <p class="text-center mb-0">
            {{ messageAddClass }}
          </p>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="$bvModal.hide('modal-validate-register-class-edit')"
              >{{ $t("reusables.cancel") }}</b-button
            >
          </template>
        </b-modal>
        <!-- ------- -->
        <div>
          <b-modal id="modal-save-change-edit" :modal-class="!flagPlanTest ? 'modal-alert-lg' : ''" :centered="true">
            <template #modal-header="{ close }">
              <img
                class="close"
                src="@/assets/img/close_red.png"
                @click="close()"
              />
              <p class="bold mb-4" v-if="!flagPlanTest">
                {{ $t("reusables.student-edited-schedule-2") }}
              </p>
            </template>
            <p class="text-center mb-0" v-if="flagPlanTest">
              {{ $t("reusables.student-edited-schedule-2") }}
            </p>
            <div class="ea-alert px-4 mb-0" v-if="!flagPlanTest">
              <div class="content">
                <div class="d-flex justify-content-center" style="gap: 5rem">
                  <div class="text-left">
                    <p class="bold">
                      {{ $t("reusables.student-edited-recurring-schedule") }}:
                    </p>
                    <ul class="mb-0" v-if="listRecurrent.length > 0">
                      <li v-for="item in listRecurrent" :key="item.date">
                        {{ item.date }}
                      </li>
                    </ul>
                    <p class="mb-0" v-else></p>
                  </div>
                  <div class="text-left">
                    <p class="bold">
                      {{ $t("reusables.student-edited-add-classes") }}:
                    </p>
                    <ul
                      class="mb-0"
                      v-if="
                        calendarOptions.events.filter((currentValue) => {
                          return (
                            currentValue.editable &&
                            !(currentValue.noRecurrent == false)
                          );
                        }).length > 0
                      "
                    >
                      <li
                        v-for="item in calendarOptions.events
                          .filter((currentValue) => {
                            return (
                              currentValue.editable &&
                              !(currentValue.noRecurrent == false)
                            );
                          })
                          .sort(
                            (a, b) => new Date(a.start) - new Date(b.start)
                          )"
                        :key="item.start"
                        :class="{
                          'red-item': item.isInList,
                        }"
                      >
                        {{ getFormatDateCompleteDetail(item.start, item.end) }}
                      </li>
                    </ul>
                    <p class="mb-0" v-else></p>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-center mt-4 form-group mx-auto align-items-center"
                  style="gap: 1rem; max-width: 20rem"
                  v-if="listResult.length > 0"
                >
                  <p class="mb-0 bold">
                    {{ $t("reusables.student-edited-schedule-17") }}
                  </p>
                </div>
              </div>
            </div>

            <template #modal-footer>
              <div class="d-flex justify-content-center w-100">
                <b-button
                  variant="danger"
                  @click="$bvModal.hide('modal-save-change-edit')"
                  >{{ $t("modals.cancel-request.button-cancel") }}</b-button
                >
                <b-button
                  @click="saveChange"
                  variant="primary"
                  class="ml-2"
                  :class="{ loading: showSpinnerSend }"
                  v-if="listResult.length == 0"
                >
                  <template v-if="!showSpinnerSend"
                    >{{ $t("class-calendar.button.2") }}
                  </template>
                  <b-spinner
                    style="width: 1rem !important; height: 1rem !important"
                    v-else
                    variant="light"
                    label="Spinning"
                  ></b-spinner>
                </b-button>
                <b-button
                  v-else
                  @click="saveChangeValidar"
                  variant="primary"
                  class="ml-2"
                  :class="{ loading: showSpinnerSend }"
                >
                  <template v-if="!showSpinnerSend"
                    >{{ $t("class-calendar.button.3") }}
                  </template>
                  <b-spinner
                    style="width: 1rem !important; height: 1rem !important"
                    v-else
                    variant="light"
                    label="Spinning"
                  ></b-spinner>
                </b-button>
              </div>
            </template>
          </b-modal>
        </div>
        <div>
          <b-modal
            id="modal-save-change-counter-send-student-edit"
            :centered="true"
          >
            <template #modal-header="{ close }">
              <img
                class="close"
                src="@/assets/img/close_red.png"
                @click="close()"
              />
            </template>
            <h5 class="bold text-center">
              {{ $t("reusables.student-edited-schedule-3") }}
            </h5>
            <p class="text-center mb-0">
              {{ $t("reusables.student-edited-schedule-4") }}
            </p>
            <template #modal-footer>
              <div class="w-100 d-flex justify-content-center">
                <b-button
                  variant="primary"
                  @click="
                    $bvModal.hide('modal-save-change-counter-send-student-edit')
                  "
                  >{{ $t("reusables.student-edited-schedule-5") }}</b-button
                >
              </div>
            </template>
          </b-modal>
        </div>
        <b-modal
          id="modal-add-event-edit"
          centered
          @close="
            showAlertModal = false;
            $bvModal.hide('modal-add-event-edit');
          "
        >
          <template #modal-header="{ close }">
            <img
              class="close"
              src="@/assets/img/close_red.png"
              @click="close()"
            />
            <h5>{{ $t("title.6") }}</h5>
          </template>
          <div></div>
          <p class="d-flex align-items-center">
            <i class="material-icons-outlined mr-3">schedule</i>
            <span>{{
              this.eventCreated != null
                ? getFormatDate(
                    this.eventCreated.startStr,
                    this.eventCreated.endStr,
                    this.lang,
                    dataStudent.flagPlanTest,
                    maximoHorasCalendario
                  )
                : ""
            }}</span>
          </p>
          <div>
            <b-alert
              show
              variant="danger"
              style="padding: 5px; font-size: 0.95rem; text-align: center"
              v-if="showAlertModal"
              >{{ message }}</b-alert
            >
          </div>
          <template #modal-footer>
            <b-button
              variant="danger"
              @click="
                showAlertModal = false;
                $bvModal.hide('modal-add-event-edit');
              "
            >
              {{ $t("modals.calendar.button") }}
            </b-button>
            <b-button @click="saveEvent" variant="primary">
              <template v-if="!showSpinnerSave">{{
                $t("modals.calendar.button-save")
              }}</template>
              <b-spinner
                style="
                  width: 1rem !important;
                  height: 1rem !important;
                  color: #ffffff;
                "
                v-else
                label="Spinning"
              ></b-spinner>
            </b-button>
          </template>
        </b-modal>
      </div>
    </b-modal>

    <b-modal
      id="modal-send-request-view"
      centered
      @close="$bvModal.hide('modal-send-request-view')"
    >
      <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()" />
      </template>
      <p>
        {{ $t("modals.modalSendRequestView.exceeded-the-maximum-number-1") }}
        {{ messageSendRequest }}
        {{ $t("modals.modalSendRequestView.exceeded-the-maximum-number-2") }}
      </p>
      <template #modal-footer>
        <b-button
          @click="$bvModal.hide('modal-send-request-view')"
          variant="primary"
          >Aceptar</b-button
        >
      </template>
    </b-modal>
    <!-- <videoPerson/> -->
    <b-modal
      id="modal-validate-save-change-counter-student-edit"
      :centered="true"
      :no-close-on-esc="true"
    >
      <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()" />
      </template>
      <p class="text-center mb-0">
        {{ message }}
      </p>
      <template #modal-footer>
        <b-button
          variant="primary"
          @click="
            $bvModal.hide('modal-validate-save-change-counter-student-edit'),
              $bvModal.hide('modal-save-change-edit')
          "
        >
          <template v-if="!showSpinnerSend">{{
            $t("reusables.buttonProgramaMasAdelante")
          }}</template>
          <b-spinner
            style="width: 1rem !important; height: 1rem !important"
            v-else
            variant="light"
            label="Spinning"
          ></b-spinner>
        </b-button>
        <b-button variant="danger" @click="saveChangeConfirm">
          {{ $t("reusables.buttonProgramaAhora") }}</b-button
        >
      </template>
    </b-modal>
    <!--MODAL CRUCE CLASES DE PROPUESTA -->
    <b-modal
      id="modal-validate-cross-edit"
      :centered="true"
      body-class="pt-2"
      footer-class="justify-content-center"
    >
      <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()" />
      </template>
      <p class="text-center mb-0">
        {{ $t("reusables.student-edited-schedule-16") }}
      </p>
      <template #modal-footer>
        <b-button
          variant="danger"
          @click="$bvModal.hide('modal-validate-cross-edit')"
          >{{ $t("reusables.cancel") }}</b-button
        >
      </template>
    </b-modal>
    <!-- ------- -->
    <modalValidateProposal
      ref="refValidProposal"
      :typeResponseEvent="typeResponseEvent"
      :messageValidate="messageValidate"
      :flagTeacher="true"
    />
  </div>
</template>

<script>
import CustomSelect from "@/components/form/select";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import interactionPlugin from "@fullcalendar/interaction";
import * as Constants from "@/assets/js/appConstants";
import { required } from "vuelidate/lib/validators";
import { validationMessage } from "vuelidate-messages";
import * as tools from "@/assets/js/tools.js";
import { IMAGENES } from "@/assets/js/appConstants";
import modalValidateProposal from "@/components/modals/modal-validate-proposal";
// import videoPerson from "@/components/modals/video-person";
import {
  getCalendarHeaderFormat,
  getCalendarTitle,
  getFormatDate,
  getCalendarEventTimeFormat,
  getCalendarHeaderToolbar,
  convertToUserTimeCalendarEvents,
  convertTimeCalendarEvents,
  getHoursByTimeZoneName,
  convertTimeToUserTime,
  convertTimeToUserTimeFormat,
  getFormatDateComplete,
  getFormatDateCompleteTitle,
  getFormatDateCompleteClass,
  getFormatDateCompleteDetail,
  getNextClassTime,
  convertTimeToUTC,
  ValidarMergeHorarios,
  getFormatDateCompleteTitleTime,
  ValidarMergeHorariosByRecurrent,
} from "@/assets/js/util.js";

const formMessagesCommentary = {
  required: function () {
    return this.$t("modals.modalViewSchedule.modal-schedule-reject.validate");
  },
};
const formUpdateDateMessages = {
  requiredFecha: function () {
    return this.$t("reusables.obligatoryField");
  },
  requiredTypeClass: function () {
    return this.$t("reusables.obligatoryField");
  },
  requiredStartDate: function () {
    return this.$t("reusables.obligatoryField");
  },
};

var _ctx = "";
let eventGuid = 0;
export function createEventId() {
  return String(eventGuid++);
}
export default {
  components: {
    FullCalendar,
    modalValidateProposal,
    CustomSelect,
    // videoPerson
  },
  props: {
    showActions: Boolean,
    pteacherDirectId: Number,
    pteacherData: Object,
  },
  data() {
    return {
      flagPlanTest: false,
      flagCancelClass: false,
      groupsPlan: {},
      infoEventoDelete: {
        startDate: null,
        endDate: null,
      },
      infoEventoRegister: {
        startDate: null,
        endDate: null,
      },
      classRegister: {
        id: "",
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
      },
      classDelete: {
        id: 0,
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
        isDelete: false,
      },
      eventDelete: null,
      eventRegister: null,
      listClassDelete: [],
      listClassRegister: [],
      classDeleteTimeClass: " ",
      showEditSchedule: true,

      showSelectWeek: true,
      uniqDateEnabled: [],
      showLoadingCalendar: false,
      uniqDate: [],
      optionsTime: [],

      optionsClassDelete: [],
      optionsClassRegister: [],
      selectedTime: null,
      getFormatDateComplete: getFormatDateComplete,
      getFormatDateCompleteTitle: getFormatDateCompleteTitle,
      getFormatDateCompleteDetail: getFormatDateCompleteDetail,
      getFormatDateCompleteTitleTime: getFormatDateCompleteTitleTime,
      getFormatDateCompleteClass: getFormatDateCompleteClass,
      arrayCalendarChange: [],
      formatDate:
        (localStorage.getItem("lang") || "es") == "es"
          ? "DD/MM/YYYY"
          : "MM/DD/YYYY",
      formatDateSchedule: "YYYY-MM-DDTHH:mm:ss",
      isResponseReceived: false,
      flagDeleteEvent: false,
      flagSendRequest: false,
      messageSendRequest: "",
      disabledButtons: false,
      daysMaxSchedule: 0,
      flagShowHeader: false,
      urlPhoto: IMAGENES,
      lang: localStorage.getItem("lang") || "es",
      arraySchedulePrivate: [],
      flagCancelEdit: false,
      showEditStudent: false,
      showModalPerson: false,
      nameWarning: "",
      hourPlanTest: [],
      hourEnabled: [],
      minDate: null,
      maxDate: null,
      disabledDate: true,
      dateStudent: null,
      typeOption: 1,
      flagConflict: false,
      showSpinnerReject: false,
      showSpinnerCancel: false,
      showSpinnerAccept: false,
      showSpinnerSend: false,
      dataStudent: {},
      dataTeacher: {},
      //colorEvent : "#cc0000",
      showLoading: false,
      directRequest: 0, //tab "Solicitud directa" ( numero varia que se muestra en este tab)
      changingValue: 0,
      events: [],
      API_URL: process.env.VUE_APP_API_URL,
      GroupScheduleCounterProposalId: 0,
      groupsScheduleProposalEditedId: null,
      PersonStudentId: 0,
      PersonTeacherId: 0,
      editHourTotal: 0,
      hourTotal: 0,
      arrayEditableSchedule: [],
      GroupId: 0,
      teacherAnswer: 1,
      FlagGroupRegisterSubject: false,
      totalCarousel: true,
      titleTeacher: true,
      showCarousel: false, //carousel ---------
      listCalendar: [],
      listCalendarTeacher: [],
      calendarEdit: false,
      arrayCalendarInit: [],
      maximoHorasCalendario: 0,
      countCall: 1,
      numSave: 0,
      message: "",
      showSpinnerSave: false,
      showSpinner: false,
      showAlertModal: false,
      dismissSecs: 5,
      disbaledTabs: true,
      dismissCountDown: 0,
      showTitleCalendar: false,
      titleCourse: "",
      flagState: false,
      SelectBeginningDate: new Date(),
      SelectBeginningDateEdit: new Date(),
      SelectBeginningDateInit: new Date(),
      eventCreated: null,
      formatDay: "",
      new_appointment: {
        title: null,
        description: null,
      },
      showButtonAccept: true,
      calendarOptions: {
        customButtons: {
          today: {
            text: `${this.$t("reusables.today")}`,
            click: () => {
              this.selectedTime = this.selectTimeInit;
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.gotoDate(new Date());
            },
          },
          prev: {
            text: "PREV",
            click: () => {
              this.selectedTime--;
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.prev();
            },
          },
          next: {
            text: "NEXT",
            click: () => {
              this.selectedTime++;
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.next();
            },
          },
        },
        eventOrder: "start,allDay,className",
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        events: [],
        eventOverlap: false,
        themeSystem: "bootstrap",
        nowIndicator: true,
        firstDay: 1,
        headerToolbar: this.getCalendarHeaderToolbarTestClass(
          this.flagShowHeader
        ),
        buttonText: {
          today: this.$t("reusables.today"),
        },
        titleFormat: function (date) {
          return getCalendarTitle(date.date, this.lang);
        },
        height: "auto",
        allDaySlot: false,
        viewDidMount: (view) => {
          let GMT = getHoursByTimeZoneName(
            this.$moment,
            this.$store.state.user.timeZoneName
          );
          view.el.querySelector(".fc-timegrid-axis-frame").innerHTML = GMT;
        },
        initialView: "timeGridWeek",
        dayHeaderContent: (args) => {
          return getCalendarHeaderFormat(
            this.$moment,
            args.date,
            this.lang,
            this.formatDay
          );
        },
        eventTimeFormat: getCalendarEventTimeFormat(),
        initialEvents: [], //INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        editable: true,
        scrollTimeReset: false,
        eventColor: Constants.CALENDAR_STATUS.CONFIRM.COLOR,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        eventResizableFromStart: false,
        select: this.handleDateSelect,
        selectAllow: this.handleSelecAllow,
        eventChange: this.handleEvents,
      },
      currentEvents: [],
      hoursEdit: 0,
      hourDisbaled: [],
      dataModal: {},
      crossingSchedule: 0,
      // value: '',
      proposal: {
        commentary: "",
      },
      getFormatDate: getFormatDate,
      typeResponseEvent: 0,
      messageValidate: "",
      ARRAY_DIA_SEMANA: Constants.DIA_SEMANA,
      listRecurrent: [],
      messageAddClass: "",
      flagChange: false,
      listResult: [],
    };
  },
  updated() {
    this.$nextTick(function () {
      tools.imgToSvg();
    });
  },
  async created() {
    this.disabledButtons = false;
    _ctx = this.API_URL;
    this.getDataPlan();
    this.getDateMinMax(new Date());
  },

  computed: {
    disabledButton() {
      let p_total = this.calendarOptions.events.filter((currentValue) => {
        return currentValue.editable;
      }).length;
      if (p_total == 0) {
        return true;
      }
      let elmts = [];
      let arrayCalendar = [];
      let arrayCalendarInit = [];
      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request;
      });
      let arraySendInit = this.arrayCalendarInit.filter((currentValue) => {
        return currentValue.request;
      });

      arraySend.forEach((element) => {
        arrayCalendar.push(
          `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
        );
      });
      arraySendInit.forEach((element) => {
        arrayCalendarInit.push(
          `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
        );
      });
      if (
        this.listClassDelete.filter(
          (item) =>
            item.id > 0 && (item.isNew === undefined || item.isNew === false)
        ).length > 0
      ) {
        return false;
      } else {
        if (arrayCalendar.length > arrayCalendarInit.length) {
          elmts = arrayCalendar.filter(function (i) {
            return this.indexOf(i) < 0;
          }, arrayCalendarInit);
        } else {
          elmts = arrayCalendarInit.filter(function (i) {
            return this.indexOf(i) < 0;
          }, arrayCalendar);
        }
        if (arraySend.length == 0) {
          return true;
        } else {
          return elmts.length == 0 ? true : false;
        }
      }
    },
    teacherId: {
      get() {
        return this.$store.state.user.personTeacherId;
      },
    },
  },
  validations: {
    proposal: {
      commentary: {
        required,
      },
    },
    classRegister: {
      typeClass: {
        requiredTypeClass(value) {
          return !(value === "" || value == null);
        },
      },
    },
    classDelete: {
      typeClass: {
        requiredTypeClass(value) {
          return !(value === "" || value == null);
        },
      },
    },
  },
  methods: {
    isFutureEvent(start) {
      const now = this.$moment();
      return this.$moment(start).isAfter(now);
    },
    validationForm: validationMessage(formUpdateDateMessages),
    validationMsgCommetary: validationMessage(formMessagesCommentary),
    modalHideSchedule() {
      if (this.showActions == true) {
        window.location.reload();
      } else {
        this.$bvModal.hide("modal-schedule");
      }
    },
    handleHideModal() {
      document.body.style.overflow = "";
      this.$nextTick(() => {
      document.documentElement.classList.remove("modal-open");
      document.querySelector(".content-main")?.classList.remove("hide-background"); 
      document.querySelector(".content-main")?.classList.remove("push-down");
      });
      this.proposal.commentary = "";
      this.$v.$reset();

      this.changingValue = 0;
      this.$bvModal.hide("modal-schedule-send");
      this.$bvModal.hide("modal-schedule");
      this.$emit("updateScheduleClassRequest");
      this.modalHideSchedule();
    },
    showModalEditStudent(
      flagEditStudent,
      dataTeacher,
      groupsScheduleProposalEditedId,
      flagPlanTest,
      groupsPlan,
      personTeacherId,
      dataGroup
    ) {
      this.dataTeacher = dataTeacher;
      this.showEditStudent = flagEditStudent;
      this.flagPlanTest = flagPlanTest;
      this.groupsScheduleProposalEditedId = groupsScheduleProposalEditedId;
      this.personTeacherId = personTeacherId;
      this.GroupId = dataGroup;
      this.groupsPlan = groupsPlan;
      this.formatDay = "";
      this.$bvModal.show("modal-schedule");
      this.flagCancelEdit = true;
      this.calendarOptions.selectable = false;
      this.showEditSchedule = true;
      this.getListSheduleEdit();
    },
    reply() {
      this.formatDay = "";
      this.flagCancelEdit = true;
      this.calendarOptions.selectable = false;
      this.showEditSchedule = true;
      this.getListSheduleEdit();
    },
    getListSheduleEdit() {
      this.showLoading = true;
      this.listCalendar = [];
      this.listCalendarTeacher = [];
      let data = {
        GroupScheduleProposalId: this.groupsScheduleProposalEditedId,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/GetEditionScheduleCounterByStudent`,
          {
            params: data,
          }
        )
        .then((response) => {
          if (response.data.entity) {
            if (this.flagPlanTest) {
              this.flagShowHeader = true;
            }
            this.isResponseReceived = response.data.entity.isResponseReceived;
            this.SelectBeginningDate = response.data.entity.beginningDate;
            const pBeginningDate =
              response.data.entity != null
                ? convertTimeToUserTime(
                    response.data.entity.detailFirst,
                    this.$store.state.user.timeZoneName,
                    this.$moment
                  )
                : null;
            this.GroupScheduleCounterProposalId =
              response.data.entity.groupScheduleCounterProposalId;
            //let arrayHours = response.data.entity.listGroupScheduleProposalDetails; //TODO: PENDIENTE TIMEZONE

            let arrayHoursTmp =
              response.data.entity.listGroupScheduleCounterProposalDetails;
            let arrayHours = convertToUserTimeCalendarEvents(
              arrayHoursTmp,
              this.$store.state.user.timeZoneName,
              this.$moment
            );
            let dataList = [];
            this.calendarOptions.headerToolbar = getCalendarHeaderToolbar(
              this.flagShowHeader
            );
            let arrayInitWeek = [];
            let arrayEnabledDate = [];
            let scheduleTotal = [];
            arrayHours.forEach((element) => {
              let startOfWeek = this.$moment(element.startDate)
                .startOf("week")
                .toDate();
              let endOfWeek = this.$moment(element.startDate)
                .endOf("week")
                .toDate();

              let month =
                parseInt(startOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(startOfWeek.getMonth()) + 1}`
                  : parseInt(startOfWeek.getMonth()) + 1;
              let dayDate =
                parseInt(startOfWeek.getDate()) < 10
                  ? `0${parseInt(startOfWeek.getDate())}`
                  : parseInt(parseInt(startOfWeek.getDate()));

              let monthEnd =
                parseInt(endOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getMonth()) + 1}`
                  : parseInt(endOfWeek.getMonth()) + 1;
              let dayDateEnd =
                parseInt(endOfWeek.getDate()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getDate()) + 1}`
                  : parseInt(parseInt(endOfWeek.getDate()) + 1);

              arrayInitWeek.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );

              arrayEnabledDate.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );
              arrayEnabledDate.push(
                endOfWeek.getFullYear() + "-" + monthEnd + "-" + dayDateEnd
              );
              this.arrayEditableSchedule.push(element.id);
              let jsonData = {
                id: createEventId(),
                title: this.$t("horario.solicitud.pending-schedule"),
                description: "",
                idx: element.id,
                start: element.startDate,
                end: element.endDate,
                color: element.noRecurrent
                  ? Constants.CALENDAR_STATUS_ADDITIONAL_COLOR.NORECURRENT
                  : Constants.CALENDAR_STATUS.CONFIRM.COLOR,
                editable: false,
                noRecurrent: element.noRecurrent,
              };

              dataList.push(jsonData);
              let data = {
                id: element.id,
                StartDate: element.startDate,
                EndDate: element.endDate,
                noRecurrent: element.noRecurrent,
              };
              this.listCalendar.push(data);
              this.listCalendarTeacher.push(data);
              scheduleTotal.push(data);
            });

            this.calendarOptions.events = dataList;
            this.showLoading = false;
            this.formatDay = "DD";
            this.optionsTime = [];
            this.uniqDateEnabled = [...new Set(arrayEnabledDate)];
            let endDateParam = this.$moment(
              this.groupsPlan.expirationDate
            ).format("YYYY-MM-DD");
            let endDate = this.$moment(this.groupsPlan.expirationDate)
              .add(1, "day")
              .endOf("day")
              .format("YYYY-MM-DD");

            if (this.listCalendar.length > 1) {
              let startDate = this.$moment(new Date()).format("YYYY-MM-DD");
              if (
                !this.$moment(endDate, "YYYY-MM-DD", true).isValid() ||
                this.$moment(endDate).isBefore(startDate)
              ) {
                endDate = startDate;
              }
              this.calendarOptions.validRange = {
                start: startDate,
                end: endDate,
              };
            }
            let startOfWeekCurrent =
              this.$moment(pBeginningDate).startOf("week");
            let endOfWeekFinal = this.$moment(endDateParam).endOf("week");
            this.uniqDate = [];
            let countSelect = 0;
            let countValited = 0;
            let weekIndex = 0;
            while (startOfWeekCurrent.isSameOrBefore(endOfWeekFinal)) {
              let startOfWeekFormatted =
                startOfWeekCurrent.format("YYYY-MM-DD");
              this.uniqDate.push(startOfWeekFormatted);
              let isBeforeCurrentWeek = startOfWeekCurrent.isBefore(
                this.$moment().startOf("week"),
                "day"
              );
              if (
                startOfWeekCurrent.isSame(this.$moment().startOf("week"), "day")
              ) {
                countSelect = weekIndex;
                countValited++;
              }

              this.optionsTime.push({
                value: weekIndex,
                text: this.$t("reusables.week") + ` ${weekIndex + 1}`,
                disabled: isBeforeCurrentWeek,
              });

              startOfWeekCurrent.add(1, "week");
              weekIndex++;
            }

            if (this.uniqDate.length > 0) {
              this.selectedTime = countSelect;
              this.selectTimeInit = countSelect;
            }

            if (countValited == 0) {
              this.selectedTime = this.uniqDate.length - 1;
              this.selectTimeInit = this.uniqDate.length - 1;
            }
          }
          this.listRecurrent = [];
          this.listRecurrent = this.groupedEventsCounter();
          setTimeout(() => {
            if (this.listCalendar.length > 0) {
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.gotoDate(this.listCalendar[0].StartDate);
            }
          }, 500);
        });
    },
    editCalendarCounterProposal() {
      this.showLoading = true;
      this.formatDay = "";
      this.calendarOptions.selectable = true;

      this.hideButtonsForEdit = true;
      this.formatDay = "";
      if (this.flagPlanTest) {
        this.formatDay = "DD";
      }
      let data = {
        PersonTeacherId: this.personTeacherId,
        GroupId: this.GroupId,
        groupscheduleproposalid: this.groupsScheduleProposalEditedId,
        timeZoneName: this.$store.state.user.timeZoneName,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsTeachers/GetScheduleCounterEditedConsolidatedByStudent`,
          {
            params: data,
          }
        )
        .then((response) => {
          if (response.data.entity != null && response.data.value == -1) {
            this.$bvModal.show("modal-not-edit");
          } else {
            const pBeginningDate =
              response.data.entity != null
                ? convertTimeToUserTime(
                    response.data.entity.startDateTz,
                    this.$store.state.user.timeZoneName,
                    this.$moment
                  )
                : null;

            this.listClassDelete = [];
            this.flagChange = false;
            this.SelectBeginningDateEdit = "";
            this.listClassRegister = [];
            this.listCalendar = [];
            this.arrayCalendarInit = [];
            this.calendarOptions.events = [];
            this.flagEdit = true;
            this.calendarOptions.selectable = true;
            this.showSelectWeek = false;
            let arrayList = response.data.list;
            this.calendarOptions.headerToolbar = getCalendarHeaderToolbar(
              this.flagShowHeader
            );
            let arrayInitWeek = [];
            let arrayEnabledDate = [];
            let scheduleTotal = [];
            arrayList.forEach((element) => {
              let startOfWeek = this.$moment(element.startDate)
                .startOf("week")
                .toDate();
              let endOfWeek = this.$moment(element.startDate)
                .endOf("week")
                .toDate();

              let month =
                parseInt(startOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(startOfWeek.getMonth()) + 1}`
                  : parseInt(startOfWeek.getMonth()) + 1;
              let dayDate =
                parseInt(startOfWeek.getDate()) < 10
                  ? `0${parseInt(startOfWeek.getDate())}`
                  : parseInt(parseInt(startOfWeek.getDate()));

              let monthEnd =
                parseInt(endOfWeek.getMonth()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getMonth()) + 1}`
                  : parseInt(endOfWeek.getMonth()) + 1;
              let dayDateEnd =
                parseInt(endOfWeek.getDate()) + 1 < 10
                  ? `0${parseInt(endOfWeek.getDate()) + 1}`
                  : parseInt(parseInt(endOfWeek.getDate()) + 1);

              arrayInitWeek.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );

              arrayEnabledDate.push(
                startOfWeek.getFullYear() + "-" + month + "-" + dayDate
              );
              arrayEnabledDate.push(
                endOfWeek.getFullYear() + "-" + monthEnd + "-" + dayDateEnd
              );
              var _id = createEventId();

              let jsonData = {
                id: _id,
                title: element.flagUpdate
                  ? this.$t("horario.calendario.label-calendar-teacher", {
                      TeacherName: this.dataTeacher.firstName,
                    })
                  : this.$t("reusables.unavailable"),
                description: "",
                idx: element.id,
                start: element.startDate,
                end:
                  this.$moment(element.endDate).format("mm") == "59"
                    ? this.$moment(element.endDate)
                        .add(1, "minutes")
                        .format("YYYY-MM-DDTHH:mm:ss")
                    : element.endDate,
                color: element.flagUpdate
                  ? element.noRecurrent
                    ? Constants.CALENDAR_STATUS_ADDITIONAL_COLOR.NORECURRENT
                    : Constants.CALENDAR_STATUS.CONFIRM.COLOR
                  : Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR,
                editable: element.flagUpdate,
                noRecurrent: element.noRecurrent,
                isNew: element.isNew,
                request: element.flagUpdate,
                idDetalle: element.scheduleEditId,
                isInList: false,
              };

              let data = {
                id: element.id,
                idx: jsonData.id,
                StartDate: element.startDate,
                EndDate:
                  this.$moment(element.endDate).format("mm") == "59"
                    ? this.$moment(element.endDate)
                        .add(1, "minutes")
                        .format("YYYY-MM-DDTHH:mm:ss")
                    : element.endDate,
                editable: element.flagUpdate,
                request: element.flagUpdate,
                noRecurrent: element.noRecurrent,
                isNew: element.isNew,
                idDetalle: element.scheduleEditId,
              };

              let dataInit = {
                id: element.id,
                idx: jsonData.id,
                StartDate: element.startDate,
                EndDate:
                  this.$moment(element.endDate).format("mm") == "59"
                    ? this.$moment(element.endDate)
                        .add(1, "minutes")
                        .format("YYYY-MM-DDTHH:mm:ss")
                    : element.endDate,
                editable: element.flagUpdate,
                request: element.flagUpdate,
                noRecurrent: element.noRecurrent,
                isNew: element.isNew,
                idDetalle: element.scheduleEditId,
              };
              this.listCalendar.push(data);
              this.arrayCalendarInit.push(dataInit);
              this.calendarOptions.events.push(jsonData);
              scheduleTotal.push(data);

              if (element.noRecurrent) {
                var idEvent = this.calendarOptions.events.find(
                  (item) => item.idDetalle == element.scheduleEditId
                );
                let objRecurrent = {
                  idx: idEvent != undefined ? idEvent.id : -1,
                  id: element.startDate + "|" + element.endDate,
                  typeClass: "true",
                  timeClass: null,
                  startDate: element.startDate,
                  endDate: element.endDate,
                  isNew: element.isNew,
                };
                this.listClassRegister.push(objRecurrent);
              }
            });
            this.formatDay = "DD";
            this.optionsTime = [];
            this.uniqDateEnabled = [...new Set(arrayEnabledDate)];
            let endDateParam = this.$moment(
              this.groupsPlan.expirationDate
            ).format("YYYY-MM-DD");
            let endDate = this.$moment(this.groupsPlan.expirationDate)
              .add(1, "day")
              .endOf("day")
              .format("YYYY-MM-DD");

            if (this.uniqDateEnabled.length > 1) {
              let startDate = this.$moment(new Date()).format("YYYY-MM-DD");
              if (
                !this.$moment(endDate, "YYYY-MM-DD", true).isValid() ||
                this.$moment(endDate).isBefore(startDate)
              ) {
                endDate = startDate;
              }
              this.calendarOptions.validRange = {
                start: startDate,
                end: endDate,
              };
            }
            let startOfWeekCurrent =
              this.$moment(pBeginningDate).startOf("week");
            let endOfWeekFinal = this.$moment(endDateParam).endOf("week");
            this.uniqDate = [];
            let countSelect = 0;
            let countValited = 0;
            let weekIndex = 0;
            while (startOfWeekCurrent.isSameOrBefore(endOfWeekFinal)) {
              let startOfWeekFormatted =
                startOfWeekCurrent.format("YYYY-MM-DD");
              this.uniqDate.push(startOfWeekFormatted);
              let isBeforeCurrentWeek = startOfWeekCurrent.isBefore(
                this.$moment().startOf("week"),
                "day"
              );

              if (
                startOfWeekCurrent.isSame(this.$moment().startOf("week"), "day")
              ) {
                countSelect = weekIndex;
                countValited++;
              }

              this.optionsTime.push({
                value: weekIndex,
                text: this.$t("reusables.week") + ` ${weekIndex + 1}`,
                disabled: isBeforeCurrentWeek,
              });

              startOfWeekCurrent.add(1, "week");
              weekIndex++;
            }

            if (this.uniqDate.length > 0) {
              this.selectedTime = countSelect;
              this.selectTimeInit = countSelect;
            }

            if (countValited == 0) {
              this.selectedTime = this.uniqDate.length - 1;
              this.selectTimeInit = this.uniqDate.length - 1;
            }
            setTimeout(() => {
              if (this.listCalendar.length > 0) {
                let calendarApi = this.$refs.fullCalendar.getApi();
                calendarApi.gotoDate(new Date());
              }
            }, 500);
            this.showEditSchedule = false;
            this.showLoading = false;
          }
        });
    },
    getDataPlan() {
      let data = {
        GroupId: this.$store.state.group_id,
      };
      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupsCoursesLessons/EntitySchedulePlanTest`,
          {
            params: data,
          }
        )
        .then((response) => {
          if (response.data.entity) {
            this.maximoHorasCalendario =
              response.data.entity.maximoHorasCalendario;
            this.flagPlanTest = response.data.entity.flagPlanTest;
            this.daysMaxSchedule = response.data.entity.daysMaxSchedule + 1;
            this.flagShowHeader = true;
            // this.formatDay = ' '
            if (response.data.entity.flagPlanTest) {
              this.flagShowHeader = true;
              //this.formatDay = 'DD'
              this.maximoHorasCalendario =
                response.data.entity.durationClassTest / 60;
            }

            this.calendarOptions.headerToolbar = getCalendarHeaderToolbar(
              this.flagShowHeader
            );
          }
        });
    },

    handleSelecAllow(selectInfo) {
      let num = this.ObtenerRangoFecha(
        selectInfo.startStr,
        selectInfo.endStr,
        this.listCalendar
      );

      if (num > 0) {
        return false;
      }

      let valueBefore = true;
      let valueAfter = this.$moment(new Date(selectInfo.start)).isAfter(
        new Date()
      );

      if (this.flagPlanTest) {
        let endAfterDate = selectInfo.end;
        let dateSelectStart = new Date(selectInfo.start);
        let arraySend = this.listCalendar.filter((currentValue) => {
          return currentValue.request;
        });

        if (arraySend.length == 1) {
          return false;
        }
        let dataStar = this.$moment(selectInfo.start);
        let dateCurrent = new Date();
        let newDateCurrent = new Date(
          dateCurrent.setMinutes(
            dateCurrent.getMinutes() - 2 * (this.maximoHorasCalendario * 60)
          )
        );
        let dataAfter = this.$moment(newDateCurrent).add(
          this.daysMaxSchedule - 1,
          "days"
        );
        valueBefore = this.$moment(dataStar).isBefore(dataAfter);

        let dateAfter = new Date(
          dateSelectStart.setMinutes(
            dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
          )
        );

        if (
          new Date(endAfterDate).getTime() <= dateAfter.getTime() &&
          valueBefore &&
          valueAfter
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        //let dataStar = this.$moment(selectInfo.start).format("YYYY-MM-DD")
        let dateSelectStart = new Date(selectInfo.start);
        let endAfter = selectInfo.end;

        let dateAfter = new Date(
          dateSelectStart.setMinutes(
            dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
          )
        );

        if (endAfter.getTime() <= dateAfter.getTime()) {
          return true;
        } else {
          return false;
        }
      }
    },
    async rejectCounterProposal() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.showSpinnerReject = true;
      let json = {
        GroupScheduleCounterProposalId: this.GroupScheduleCounterProposalId,
        Value: this.proposal.commentary,
        UserMail: this.$store.state.user.email,
      };

      let flagContinue = await this.validateCounterProposal(
        json.GroupScheduleCounterProposalId
      );
      if (!flagContinue) {
        return;
      }

      baseInstanceAxios
        .post(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/RejectScheduleCounterByTeacher`,
          json
        )
        .then((response) => {
          this.message = this.$t("horario.solicitud.msg-1"); //"Se rechazó correctamente la contrapropuesta o solicitud."
          this.$bvToast.show("toast-check-modal-request-class");
          //this.$emit('updateSchedule')
          this.showSpinnerReject = false;
          this.$bvModal.hide("modal-schedule-cancel");
          this.$bvModal.hide("modal-schedule");
          this.$emit("updateSchedule");
          this.modalHideSchedule();
        });
    },

    cancelCounterProposal() {
      this.showSpinnerCancel = true;
      if (this.flagCancelEdit) {
        let data = {
          GroupScheduleProposalId: this.groupsScheduleProposalEditedId,
        };
        baseInstanceAxios
          .get(
            `${this.apiURL}/resources/GroupScheduleCounterProposal/CancelEditionScheduleByTeacher`,
            {
              params: data,
            }
          )
          .then((response) => {
            this.message = this.$t("horario.solicitud.msg-2"); //`Se ha cancelado correctamente.`;

            this.$bvToast.show("toast-check-modal-request-class");
            this.$bvModal.hide("modal-schedule-cancel");
            this.$bvModal.hide("modal-schedule");
            this.$emit("updateSchedule");
            this.showSpinnerCancel = false;
            if (this.$store.state.user != null) {
              this.$store.state.user.isResponseReceived = false;
              this.$store.commit("mutateUser", this.$store.state.user);
            }
            this.modalHideSchedule();
          })
          .catch((err) => {
            this.showSpinnerCancel = false;
            this.message = this.$t("horario.solicitud.msg-3"); //`Hubo un error al cancelar el horario nuevo pendiente.`;

            this.$bvToast.show("toast-equis-modal-request-class");
          });
      } else {
        let json = {
          GroupScheduleCounterProposalId: this.GroupScheduleCounterProposalId,
          Code: Constants.TYPE_SCHEDULE_SEND.EARRING.CODE,
          Value: Constants.TYPE_SCHEDULE_SEND.EARRING.VALUE,
          BeginningDate: this.SelectBeginningDate,
          UserMail: this.$store.state.user.email,
        };

        baseInstanceAxios
          .post(
            `${this.apiURL}/resources/GroupScheduleCounterProposal/AcceptCancelScheduleCounterByTeacher`,
            json
          )
          .then((response) => {
            this.message = this.$t("horario.solicitud.msg-4"); //"Se canceló correctamente su contrapropuesta."
            this.$bvToast.show("toast-check-modal-request-class");
            //this.$emit('updateSchedule')
            this.showSpinnerCancel = false;
            this.$bvModal.hide("modal-schedule-cancel");
            this.$bvModal.hide("modal-schedule");
            this.$emit("updateSchedule");
            this.modalHideSchedule();
          });
      }
    },

    async acceptCounterProposal() {
      this.crossingSchedule = 0;
      let arrayScheduleTeacher = this.listCalendar.filter((currentValue) => {
        return !currentValue.request && !currentValue.flagPlantTest;
      });

      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request;
      });

      let arrayNotAvailable = this.listCalendar.filter((currentValue) => {
        return !currentValue.request;
      });

      let sumtotal = 0;
      let arrayNew = [];

      arraySend.forEach((element) => {
        arrayNew.push({
          StartDate: element.StartDate,
          EndDate: element.EndDate,
        });
        let flagRangoFecha = this.ObtenerRangoFecha(
          element.StartDate,
          element.EndDate,
          arrayNotAvailable
        );
        sumtotal += flagRangoFecha;
      });

      if (this.dataStudent.flagPlanTest) {
        this.SelectBeginningDate = new Date(arrayNew[0].StartDate);
      }

      let json = {
        GroupScheduleCounterProposalId: this.GroupScheduleCounterProposalId,
        Code: Constants.TYPE_SCHEDULE_SEND.ACCEPTED.CODE,
        Value: Constants.TYPE_SCHEDULE_SEND.ACCEPTED.VALUE,
        BeginningDate: this.SelectBeginningDate,
        FlagPlanTest: this.dataStudent.flagPlanTest,
        UserMail: this.$store.state.user.email,
      };

      if (!this.disabledDate) {
        let dateCurrent = new Date(this.SelectBeginningDate);

        let dateCurrentFormat = new Date(
          dateCurrent.getFullYear(),
          dateCurrent.getMonth(),
          dateCurrent.getDate(),
          0,
          0,
          0
        );
        let dateMinFormat = new Date(
          this.minDate.getFullYear(),
          this.minDate.getMonth(),
          this.minDate.getDate(),
          0,
          0,
          0
        );
        if (this.$moment(dateCurrentFormat).isSameOrAfter(dateMinFormat)) {
          this.showSpinnerAccept = true;

          let sumSchedule = 0;
          arraySend.forEach((element) => {
            let flagRangoFecha = this.ObtenerRangoFecha(
              element.StartDate,
              element.EndDate,
              arrayScheduleTeacher
            );

            sumSchedule += flagRangoFecha;
          });

          if (sumSchedule == 0) {
            this.showSpinnerAccept = true;

            let flagContinue = await this.validateCounterProposal(
              json.GroupScheduleCounterProposalId
            );
            if (!flagContinue) {
              return;
            }
            baseInstanceAxios
              .post(
                `${this.apiURL}/resources/GroupScheduleCounterProposal/AcceptCancelScheduleCounterByTeacher`,
                json
              )
              .then((response) => {
                this.message = this.$t("horario.solicitud.msg-5"); //"Se aceptó correctamente la contrapropuesta o solicitud."
                this.$bvToast.show("toast-check-modal-request-class");
                //this.$emit('updateSchedule')
                this.showSpinnerAccept = false;
                this.$bvModal.hide("modal-schedule-acept");
                this.$bvModal.hide("modal-schedule");
                this.$emit("updateSchedule");
                this.modalHideSchedule();
              });
          } else {
            this.showSpinnerAccept = false;
            this.crossingSchedule = 1;
            this.showButtonAccept = false;
            this.nameWarning = this.$t("view-schedule.validate.1");
          }
        } else {
          this.showSpinnerAccept = false;
          this.crossingSchedule = 1;
          this.nameWarning = this.$t("horario.solicitud.msg-6"); //"Debes cambiar la fecha de inicio a una fecha posterior del ultimo cruce de la clase de prueba."
        }
      } else {
        this.crossingSchedule = sumtotal;
        if (sumtotal == 0) {
          this.showSpinnerAccept = true;

          let flagContinue = await this.validateCounterProposal(
            json.GroupScheduleCounterProposalId
          );
          if (!flagContinue) {
            return;
          }
          baseInstanceAxios
            .post(
              `${this.apiURL}/resources/GroupScheduleCounterProposal/AcceptCancelScheduleCounterByTeacher`,
              json
            )
            .then((response) => {
              this.message = this.$t("horario.solicitud.msg-5");
              this.$bvToast.show("toast-check-modal-request-class");
              //this.$emit('updateSchedule')
              this.showSpinnerAccept = false;
              this.$bvModal.hide("modal-schedule-acept");
              this.$bvModal.hide("modal-schedule");
              this.$emit("updateSchedule");
              this.modalHideSchedule();
            });
        } else {
          this.showSpinnerAccept = false;
          this.showButtonAccept = false;
          this.nameWarning = this.$t("view-schedule.validate.1");
        }
      }
    },

    async sendCounterProposal() {
      //this.changingValue++
      if (this.flagCancelEdit) {
        this.showSpinnerSend = true;

        let data = {
          GroupScheduleProposalId: this.groupsScheduleProposalEditedId,
          UserMail: this.$store.state.user.email,
        };
        //GH => Consultar
        baseInstanceAxios
          .get(
            `${this.apiURL}/resources/GroupScheduleCounterProposal/ResendChangRequest`,
            {
              params: data,
            }
          )
          .then((response) => {
            if (response.data.value == 0) {
              this.message = this.$t("horario.solicitud.msg-7");
              this.$bvToast.show("toast-equis-modal-request-class");
            }

            if (response.data.value == 1) {
              this.message = this.$t("horario.solicitud.msg-8");
              this.$bvToast.show("toast-equis-modal-request-class");
            }

            if (response.data.value == 2) {
              this.message = this.$t("horario.solicitud.msg-9");
              this.$bvToast.show("toast-check-modal-request-class");
              this.$bvModal.hide("modal-schedule-cancel");
              this.$bvModal.hide("modal-schedule");
              this.$emit("updateSchedule");
              this.modalHideSchedule();
            }

            this.showSpinnerSend = false;
          })
          .catch((err) => {
            this.showSpinnerSend = false;
            this.message = this.$t("horario.solicitud.msg-10");
            this.$bvToast.show("toast-equis-modal-request-class");
          });
      } else {
        this.crossingSchedule = 0;

        let sumtotal = 0;
        let arrayScheduleTeacher = this.listCalendar.filter((currentValue) => {
          return !currentValue.request && !currentValue.flagPlantTest;
        });
        let arraySend = this.listCalendar.filter((currentValue) => {
          return currentValue.request;
        });

        let arrayNotAvailable = this.listCalendar.filter((currentValue) => {
          return !currentValue.request;
        });

        let arrayNew = [];
        arraySend.forEach((element) => {
          arrayNew.push({
            StartDate: element.StartDate,
            EndDate: element.EndDate,
          });
          let flagRangoFecha = this.ObtenerRangoFecha(
            element.StartDate,
            element.EndDate,
            arrayNotAvailable
          );

          sumtotal += flagRangoFecha;
        });

        if (this.dataStudent.flagPlanTest) {
          this.SelectBeginningDate = new Date(arrayNew[0].StartDate);
        }
        this.dataModal = {
          PersonTeacherId: this.PersonTeacherId,
          BeginningDate: this.SelectBeginningDate,
          Code: Constants.TYPE_PROPOSAL_SEND.TEACHER_PROPOSAL.CODE,
          Value: Constants.TYPE_PROPOSAL_SEND.TEACHER_PROPOSAL.VALUE,
          GroupScheduleCounterProposalID: this.GroupScheduleCounterProposalId,
          ListGroupScheduleCounterProposalDetails: arrayNew,
          FlagPlanTest: this.dataStudent.flagPlanTest,
          UserMail: this.$store.state.user.email,
          //ListScheduleTeachersDetails: []
        };

        if (!this.disabledDate) {
          let dateCurrent = new Date(this.SelectBeginningDate);

          let dateCurrentFormat = new Date(
            dateCurrent.getFullYear(),
            dateCurrent.getMonth(),
            dateCurrent.getDate(),
            0,
            0,
            0
          );
          let dateMinFormat = new Date(
            this.minDate.getFullYear(),
            this.minDate.getMonth(),
            this.minDate.getDate(),
            0,
            0,
            0
          );
          if (this.$moment(dateCurrentFormat).isSameOrAfter(dateMinFormat)) {
            this.showSpinnerSend = true;
            let sumSchedule = 0;

            arraySend.forEach((element) => {
              let flagRangoFecha = this.ObtenerRangoFecha(
                element.StartDate,
                element.EndDate,
                arrayScheduleTeacher
              );

              sumSchedule += flagRangoFecha;
            });

            if (sumSchedule == 0) {
              convertTimeCalendarEvents(
                this.dataModal.ListGroupScheduleCounterProposalDetails,
                this.$store.state.user.timeZoneName,
                this.$moment
              );
              let flagContinue = await this.validateCounterProposal(
                this.dataModal.GroupScheduleCounterProposalID
              );
              if (!flagContinue) {
                return;
              }

              this.showSpinnerSend = true;

              baseInstanceAxios
                .post(
                  `${this.apiURL}/resources/GroupScheduleCounterProposal/SaveScheduleTeacherAvailabilityAndCounterProposal`,
                  this.dataModal
                )
                .then((response) => {
                  this.showSpinnerSave = false;
                  this.message = this.$t(
                    "modals.modalConfirmPrivate.message-success"
                  );
                  this.$bvToast.show("toast-check-modal-request-class");
                  //this.$emit('updateSchedule')
                  this.showSpinnerSend = false;
                  this.editCalendarHorario(2);
                  this.$bvModal.hide("modal-schedule-send");
                  this.$bvModal.hide("modal-schedule");
                  this.$emit("updateSchedule");
                  this.modalHideSchedule();
                });
            } else {
              this.showSpinnerSend = false;
              this.crossingSchedule = 1;
              this.nameWarning = this.$t("view-schedule.validate.1");
            }
          } else {
            this.showSpinnerSend = false;
            this.crossingSchedule = 1;
            this.nameWarning = this.$t("horario.solicitud.msg-6");
          }
        } else {
          this.crossingSchedule = sumtotal;
          if (sumtotal == 0) {
            this.showSpinnerSend = true;

            convertTimeCalendarEvents(
              this.dataModal.ListGroupScheduleCounterProposalDetails,
              this.$store.state.user.timeZoneName,
              this.$moment
            );
            let flagContinue = await this.validateCounterProposal(
              this.dataModal.GroupScheduleCounterProposalID
            );
            if (!flagContinue) {
              return;
            }
            baseInstanceAxios
              .post(
                `${this.apiURL}/resources/GroupScheduleCounterProposal/SaveScheduleTeacherAvailabilityAndCounterProposal`,
                this.dataModal
              )
              .then((response) => {
                this.showSpinnerSave = false;
                this.message = this.$t(
                  "modals.modalConfirmPrivate.message-success"
                );
                this.$bvToast.show("toast-check-modal-request-class");
                //this.$emit('updateSchedule')
                this.showSpinnerSend = false;
                this.editCalendarHorario(2);
                this.$bvModal.hide("modal-schedule-send");
                this.$bvModal.hide("modal-schedule");
                this.$emit("updateSchedule");
                this.modalHideSchedule();
              });
          } else {
            this.showSpinnerSend = false;
            this.nameWarning = this.$t("view-schedule.validate.1");
          }
        }
      }
    },

    editCalendarHorario(type) {
      //this.btnSend = true;
      //this.btnOutCarousel = false;
      if (type == 1) {
        this.changingValue++;
        this.calendarOptions.selectable = true;

        this.arrayEditableSchedule.forEach((id) => {
          this.calendarOptions.events.forEach((element) => {
            if (element.idx == id) {
              element.editable = true;
            }
          });
        });
      } else {
        this.changingValue--;
        this.getListHours();
      }
    },
    async ValidateIsScheduleDirectTotal() {
      let query = {
        GroupId: this.$store.state.group_id,
      };

      await baseInstanceAxios
        .get(
          `${this.apiURL}/Resources/PersonsTeachers/ValidateIsScheduleDirectTotal`,
          {
            params: query,
          }
        )
        .then((response) => {
          if (response.data) {
            this.flagSendRequest = response.data.return;
            this.messageSendRequest = response.data.message;
          }
        })
        .catch((err) => {
          console.log("err : ", err);
        });
    },
    async showModalAndDate() {
      await this.ValidateIsScheduleDirectTotal();

      if (this.flagSendRequest) {
        this.$bvModal.show("modal-send-request-view");
      } else {
        this.$bvModal.hide("modal-schedule");
        //this.directRequest=1;
        //this.$emit('RequestDirect',this.directRequest)
        this.$emit("getParamsChild");
        this.$emit("getListScheduleTeacherModal", this.pteacherDirectId);
      }
    },

    getScheduleTeacher(
      teacherId,
      groupId,
      flagEdited,
      teacherData,
      flagPlanTest
    ) {
      this.dataTeacher = teacherData;
      this.$bvModal.show("modal-schedule");
      this.getListScheduleTeacher(teacherId, groupId, flagEdited, flagPlanTest);
    },

    getListScheduleTeacher(id, groupId, flagEdited, flagPlanTest) {
      this.showLoading = true;
      let data = {
        PersonTeacherId: id,
        GroupId: groupId,
        FlagChangeTeacher: flagEdited,
        FlagPlanTest: flagPlanTest,
        timeZoneName: this.$store.state.user.timeZoneName,
      };

      baseInstanceAxios
        .get(_ctx + "/resources/PersonsTeachers/GetByIdTeacherAvailability", {
          params: data,
        })
        .then((response) => {
          let arrayHours = response.data.entity.dtoScheduleTeachersDetails; //TODO: PENDIENTE TIMEZONE

          this.SelectBeginningDate = response.data.entity.beginningDate;
          let dataList = [];
          let id = 0;
          arrayHours.forEach((element) => {
            let colorResquest = "";
            let titleClass = "";

            if (
              Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST ==
                element.typeOfSchedule ||
              Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE ==
                element.typeOfSchedule
            ) {
              titleClass = this.$t("reusables.student");

              colorResquest = Constants.CALENDAR_STATUS.CONFIRM.COLOR;
              this.arrayEditableSchedule.push(id);
            }
            if (
              Constants.TYPE_OF_SCHEDULE.SCHEDULE_CLASSES_TEACHER ==
              element.typeOfSchedule
            ) {
              //colorResquest = "#03c2fc";
              colorResquest = Constants.CALENDAR_STATUS.PENDIENT.COLOR;
              //titleClass = `Clases - ${element.persons.strFullName}`
              titleClass = this.$t("reusables.class-scheduled");
              if (element.flagPlanTest) {
                titleClass = this.$t("reusables.test-class"); //"Clase de prueba";
              }

              let jsonData = {
                id: createEventId(),
                title: titleClass,
                description: "",
                idx: id,
                start: element.startDate,
                end: element.endDate,
                color: colorResquest,
                editable: false,
                isInList: false,
              };

              let data = {
                id: id,
                StartDate: element.startDate,
                EndDate: element.endDate,
                request: element.id != 0 ? true : false,
              };
              id++;
              dataList.push(jsonData);
              this.listCalendar.push(data);
            }
            if (
              Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE ==
              element.typeOfSchedule
            ) {
              colorResquest = Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR;
              titleClass = this.$t("view-schedule.titleClass.3");

              let jsonData = {
                id: createEventId(),
                title: titleClass,
                description: "",
                idx: id,
                start: element.startDate,
                end: element.endDate,
                color: colorResquest,
                editable: false,
                isInList: false,
              };

              let data = {
                id: id,
                StartDate: element.startDate,
                EndDate: element.endDate,
                request: element.id != 0 ? true : false,
              };
              id++;
              dataList.push(jsonData);
              this.listCalendar.push(data);
            }
          });
          this.calendarOptions.events = dataList;

          setTimeout(() => {
            if (dataList.length > 0) {
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.gotoDate(dataList[0].start);
            }
          }, 500);

          this.calendarOptions.selectable = false;

          this.showLoading = false;
        })
        .catch((err) => {
          console.log("err : ", err);
        });
    },

    openModalmorebtnDisabled() {
      this.$bvModal.show("modal-schedule");
      setTimeout(() => {
        if (this.changingValue == 0) {
          document.getElementById("btnScheduleDisabled").disabled = true;
        }
      }, 10);
    },
    saveEvent() {
      let fechaInicio = this.eventCreated.startStr;
      let fechaFin = this.eventCreated.endStr;

      this.editHourTotal += this.hoursEdit;

      let idx = this.obtenerCalendarId();

      //let currentStart = new Date(fechaInicio)
      let dateSelectStart = new Date(fechaInicio);
      let dateSelectEnd = new Date(fechaFin);
      let dateEnd = null;

      if (this.flagPlanTest) {
        let dateAfter = new Date(
          dateSelectStart.setMinutes(
            dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
          )
        );
        dateEnd = dateAfter;
      } else {
        let dateAfter = new Date(
          dateSelectStart.setMinutes(
            dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
          )
        );
        if (dateSelectEnd.getTime() < dateAfter.getTime()) {
          dateEnd = fechaFin;
        } else {
          dateEnd = dateAfter;
        }
      }

      let num = this.ObtenerRangoFecha(fechaInicio, dateEnd, this.listCalendar);
      if (num == 0) {
        let eventData;
        //let eventMerge = false;
        let _eventItemMerge = ValidarMergeHorarios(
          this.calendarOptions.events,
          fechaInicio,
          dateEnd,
          this.$moment
        );

        if (Object.keys(_eventItemMerge).length != 0) {
          //si hay merge

          this.arrayCalendarChange.forEach((obj, i) => {
            if (obj.id == _eventItemMerge.idx) {
              obj.StartDate = this.$moment(_eventItemMerge.start).format(
                this.formatDateSchedule
              );
              obj.EndDate = this.$moment(_eventItemMerge.end).format(
                this.formatDateSchedule
              );
            }
          });
          this.listCalendar.forEach((obj, i) => {
            if (
              obj.idx ==
              (_eventItemMerge.idx == 0
                ? _eventItemMerge.id
                : parseInt(_eventItemMerge.idx, 10))
            ) {
              obj.StartDate = this.$moment(_eventItemMerge.start).format(
                this.formatDateSchedule
              );
              obj.EndDate = this.$moment(_eventItemMerge.end).format(
                this.formatDateSchedule
              );
            }
          });
        } else {
          eventData = {
            id: idx,
            StartDate: this.$moment(fechaInicio).format(
              this.formatDateSchedule
            ),
            EndDate: this.$moment(dateEnd).format(this.formatDateSchedule),
            StateClass: Constants.CALENDAR_STATUS.CONFIRM.VALUE,
            request: true,
            editable: true,
          };
          this.arrayCalendarChange.push(eventData);
          this.listCalendar.push(eventData);

          this.calendarOptions.events.push({
            idx: idx,
            id: createEventId(),
            description: "",
            start: this.$moment(fechaInicio).format(this.formatDateSchedule),
            end: this.$moment(dateEnd).format(this.formatDateSchedule),
            title: this.$t("horario.calendario.label-calendar-teacher", {
              TeacherName: this.dataTeacher.firstName,
            }),
            request: true,
            editable: true,
            isInList: false,
          });
        }

        this.disabledDate = false;

        this.getDateMinMax(new Date());
        this.$bvModal.hide("modal-add-class-plan-test");
      } else {
        this.message = `${this.$t(
          "modals.modalViewSchedule.maximoHorasCalendario.1"
        )} ${this.maximoHorasCalendario * 60} ${this.$t(
          "modals.modalViewSchedule.maximoHorasCalendario.2"
        )} `;
        this.$bvToast.show("toast-equis-modal-calendar-class");
      }

      this.$bvModal.hide("modal-add-class-plan-test");
    },
    removeEvent(event) {
      if (this.flagPlanTest) {
        this.removeEventPlanTest(event);
      } else {
        let eventCurrent = this.calendarOptions.events.find((currentValue) => {
          return parseInt(currentValue.id) == event.id && currentValue.isNew;
        });
        this.eventDelete = event;
        if (eventCurrent == undefined) {
          this.GetScheduleByDelete(event);
        } else {
          this.classDelete.isNew = true;
          this.SaveClassDeleteByNew(event, eventCurrent.noRecurrent);
          this.listClassRegister = this.listClassRegister.filter(
            (currentValue) => {
              return (
                currentValue.idx == undefined ||
                !(parseInt(currentValue.idx) == event.id && currentValue.isNew)
              );
            }
          );
        }
      }
    },
    removeEventPlanTest(event) {
      this.arrayCalendarChange = this.arrayCalendarChange.filter(function (e) {
        return (
          new Date(e.StartDate).getTime() !=
            new Date(event.startStr).getTime() &&
          new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
        );
      });
      this.listCalendar = this.listCalendar.filter(function (e) {
        return (
          new Date(e.StartDate).getTime() !=
            new Date(event.startStr).getTime() &&
          new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
        );
      });
      this.calendarOptions.events = this.calendarOptions.events.filter(
        function (e) {
          return (
            new Date(e.start).getTime() != new Date(event.startStr).getTime() &&
            new Date(e.end).getTime() != new Date(event.endStr).getTime()
          );
        }
      );

      if (this.arrayCalendarChange.length > 0) {
        this.disabledDate = false;
        this.getDateMinMax(new Date());
      } else {
        this.disabledDate = true;
        this.SelectBeginningDate = new Date();
      }

      event.remove();
    },
    SaveClassDeleteByNew(event, noRecurrent) {
      this.classDelete.id = event.id;
      this.infoEventoDelete.startDate = event.start;
      this.infoEventoDelete.endDate = event.end;
      this.idValueSelectEventSelectedTimeClassDelete(event);
      if (!noRecurrent) {
        this.$bvModal.show("delete-recurring-class-edit");
      } else {
        this.$bvModal.show("modal-delete-class-edit");
      }
    },
    SaveClassDeleteByNewConfirm(event, noRecurrent) {
      if (noRecurrent) {
        this.arrayCalendarChange = this.arrayCalendarChange.filter(function (
          e
        ) {
          return (
            new Date(e.StartDate).getTime() !=
              new Date(event.startStr).getTime() &&
            new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
          );
        });
        this.listCalendar = this.listCalendar.filter(function (e) {
          return (
            new Date(e.StartDate).getTime() !=
              new Date(event.startStr).getTime() &&
            new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
          );
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(
          function (e) {
            return (
              new Date(e.start).getTime() !=
                new Date(event.startStr).getTime() &&
              new Date(e.end).getTime() != new Date(event.endStr).getTime()
            );
          }
        );
      } else {
        const eventDayOfWeek = new Date(event.startStr).getDay();
        const eventTimeStart = event.startStr.slice(11, 16);
        const eventTimeEnd = event.endStr.slice(11, 16);
        const eventDate = new Date(event.startStr);

        this.arrayCalendarChange = this.arrayCalendarChange.filter((e) => {
          const eventStartDate = new Date(e.StartDate);
          return !(
            eventStartDate.getDay() === eventDayOfWeek &&
            e.StartDate.slice(11, 16) === eventTimeStart &&
            e.EndDate.slice(11, 16) === eventTimeEnd &&
            e.noRecurrent === false &&
            e.request === true &&
            eventStartDate >= eventDate
          );
        });

        this.listCalendar = this.listCalendar.filter((e) => {
          const eventStartDate = new Date(e.StartDate);
          return !(
            eventStartDate.getDay() === eventDayOfWeek &&
            e.StartDate.slice(11, 16) === eventTimeStart &&
            e.EndDate.slice(11, 16) === eventTimeEnd &&
            e.noRecurrent === false &&
            e.request === true &&
            eventStartDate >= eventDate
          );
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(
          (e) => {
            const eventStartDate = new Date(e.start);
            return !(
              eventStartDate.getDay() === eventDayOfWeek &&
              e.start.slice(11, 16) === eventTimeStart &&
              e.end.slice(11, 16) === eventTimeEnd &&
              e.noRecurrent === false &&
              e.request === true &&
              eventStartDate >= eventDate
            );
          }
        );

        // eliminar evento actual
        this.arrayCalendarChange = this.arrayCalendarChange.filter(function (
          e
        ) {
          if (e.noRecurrent === true) {
            return true;
          }
          return (
            new Date(e.StartDate).getTime() !=
              new Date(event.startStr).getTime() &&
            new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
          );
        });
        this.listCalendar = this.listCalendar.filter(function (e) {
          if (e.noRecurrent === true) {
            return true;
          }
          return (
            new Date(e.StartDate).getTime() !=
              new Date(event.startStr).getTime() &&
            new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
          );
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(
          function (e) {
            if (e.noRecurrent === true) {
              return true;
            }
            return (
              new Date(e.start).getTime() !=
                new Date(event.startStr).getTime() &&
              new Date(e.end).getTime() != new Date(event.endStr).getTime()
            );
          }
        );
      }

      if (this.arrayCalendarChange.length > 0) {
        this.disabledDate = false;
        this.getDateMinMax(new Date());
      } else {
        this.disabledDate = true;
        this.SelectBeginningDate = new Date();
      }
      event.remove();
      this.classDelete = {
        id: 0,
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
        isDelete: false,
      };
      this.classDeleteTimeClass = " ";

      this.$bvModal.hide("delete-recurring-class-edit");
      this.$v.classDelete.$reset();
    },
    GetScheduleByDelete(event) {
      this.classDeleteTimeClass = " ";
      var startDate = convertTimeToUTC(
        event.start,
        this.$store.state.user.timeZoneName,
        this.$moment
      );
      var endDate = convertTimeToUTC(
        event.end,
        this.$store.state.user.timeZoneName,
        this.$moment
      );

      this.infoEventoDelete.startDate = event.start;
      this.infoEventoDelete.endDate = event.end;
      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/PersonsTeachers/GetScheduleByDelete?startDate=${startDate}&endDate=${endDate}&groupPlanId=${this.groupsPlan.id}`
        )

        .then((response) => {
          if (response.data != null) {
            if (response.data.value == 0) {
              this.$bvModal.show("modal-delete-class-without-result-edit");
            } else {
              this.classDelete.id = response.data.value;
              this.idValueSelectEventSelectedTimeClassDelete(event);
              if (!response.data.return) {
                this.$bvModal.show("delete-recurring-class-edit");
              } else {
                this.$bvModal.show("modal-delete-class-edit");
              }
            }
          }
        });
    },
    SaveClassDelete() {
      this.$v.classDelete.$touch();
      if (this.$v.classDelete.$invalid) {
        return;
      } else {
        const event = this.eventDelete;
        if (
          this.classDelete.isNew != undefined &&
          this.classDelete.isNew == true
        ) {
          this.SaveClassDeleteByNewConfirm(
            event,
            this.classDelete.typeClass === "false" ? false : true
          );
          this.listClassRegister = this.listClassRegister.filter(
            (currentValue) => {
              return (
                currentValue.idx == undefined ||
                !(parseInt(currentValue.idx) == event.id && currentValue.isNew)
              );
            }
          );
        } else {
          if (
            this.eventDelete != null &&
            this.classDelete.typeClass === "false"
          ) {
            const eventDayOfWeek = new Date(event.startStr).getDay();
            const eventTimeStart = event.startStr.slice(11, 16);
            const eventDate = new Date(event.startStr);
            const eventTimeEnd = event.endStr.slice(11, 16);
            this.arrayCalendarChange = this.arrayCalendarChange.filter((e) => {
              const eventStartDate = new Date(e.StartDate);
              return !(
                eventStartDate.getDay() === eventDayOfWeek &&
                e.StartDate.slice(11, 16) === eventTimeStart &&
                e.EndDate.slice(11, 16) === eventTimeEnd &&
                e.noRecurrent === false &&
                e.request === true &&
                eventStartDate >= eventDate
              );
            });
            this.listCalendar = this.listCalendar.filter((e) => {
              const eventStartDate = new Date(e.StartDate);
              return !(
                eventStartDate.getDay() === eventDayOfWeek &&
                e.StartDate.slice(11, 16) === eventTimeStart &&
                e.EndDate.slice(11, 16) === eventTimeEnd &&
                e.noRecurrent === false &&
                e.request === true &&
                eventStartDate >= eventDate
              );
            });
            this.calendarOptions.events = this.calendarOptions.events.filter(
              (e) => {
                const eventStartDate = new Date(e.start);
                return !(
                  eventStartDate.getDay() === eventDayOfWeek &&
                  e.start.slice(11, 16) === eventTimeStart &&
                  e.end.slice(11, 16) === eventTimeEnd &&
                  e.noRecurrent === false &&
                  e.request === true &&
                  eventStartDate >= eventDate
                );
              }
            );

            if (this.arrayCalendarChange.length > 0) {
              this.getDateMinMax(new Date());
            } else {
              this.SelectBeginningDate = new Date();
            }

            this.eventDelete = null;
          } else {
            this.listClassDelete.push(this.classDelete);
            this.arrayCalendarChange = this.arrayCalendarChange.filter(
              function (e) {
                return (
                  new Date(e.StartDate).getTime() !=
                    new Date(event.startStr).getTime() &&
                  new Date(e.EndDate).getTime() !=
                    new Date(event.endStr).getTime()
                );
              }
            );
            this.listCalendar = this.listCalendar.filter(function (e) {
              return (
                new Date(e.StartDate).getTime() !=
                  new Date(event.startStr).getTime() &&
                new Date(e.EndDate).getTime() !=
                  new Date(event.endStr).getTime()
              );
            });
            this.calendarOptions.events = this.calendarOptions.events.filter(
              function (e) {
                return (
                  new Date(e.start).getTime() !=
                    new Date(event.startStr).getTime() &&
                  new Date(e.end).getTime() != new Date(event.endStr).getTime()
                );
              }
            );
          }
        }

        event.remove();
        this.classDelete = {
          id: 0,
          typeClass: null,
          timeClass: null,
          startDate: null,
          endDate: null,
          isDelete: false,
        };
        this.classDeleteTimeClass = " ";
        this.$bvModal.hide("delete-recurring-class-edit");
        this.$v.classDelete.$reset();
      }
    },
    SaveClassDeleteNoRecurrent() {
      var event = this.eventDelete;
      this.arrayCalendarChange = this.arrayCalendarChange.filter(function (e) {
        return (
          new Date(e.StartDate).getTime() !=
            new Date(event.startStr).getTime() &&
          new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
        );
      });
      this.listCalendar = this.listCalendar.filter(function (e) {
        return (
          new Date(e.StartDate).getTime() !=
            new Date(event.startStr).getTime() &&
          new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
        );
      });
      this.calendarOptions.events = this.calendarOptions.events.filter(
        function (e) {
          return (
            new Date(e.start).getTime() != new Date(event.startStr).getTime() &&
            new Date(e.end).getTime() != new Date(event.endStr).getTime()
          );
        }
      );

      if (this.arrayCalendarChange.length > 0) {
        this.getDateMinMax(new Date());
      } else {
        this.SelectBeginningDate = new Date();
      }
      this.listClassDelete.push(this.classDelete);
      event.remove();
      this.eventDelete = null;
      this.classDelete = {
        id: 0,
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
        isDelete: false,
      };
      this.$bvModal.hide("modal-delete-class-edit");
    },
    idValueSelectEventSelectedTime(event) {
      this.selectedTime = event;
    },
    getWeek() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.gotoDate(this.uniqDate[this.selectedTime]);
    },
    idValueSelectEventSelectedTimeClassRegister(event) {
      if (event != null) {
        this.classRegister.id = 0;
        this.classRegister.startDate = event.startStr;
        this.classRegister.endDate = event.endStr;
        this.classRegister.noRecurrent = true;
        this.classRegister.stateClassId = parseInt(
          Constants.CALENDAR_STATUS.CONFIRM.VALUE
        );
        this.classRegister.isNew = true;
      }
    },
    idValueSelectEventSelectedTimeClassDelete(event) {
      if (event != null) {
        this.classDelete.startDate = event.start;
        this.classDelete.endDate = event.end;
        this.classDelete.isDelete = true;
        this.classDelete.stateClassId = parseInt(
          Constants.CALENDAR_STATUS.CONFIRM.VALUE
        );
      }
    },
    getDateMinMax(minDateArray) {
      this.minDate = new Date(minDateArray);

      let d = new Date(minDateArray),
        diff = d.getDate() + 7; //TODO:Validar param
      this.maxDate = new Date(d.setDate(diff));
    },
    async saveChange() {
      if (this.flagPlanTest) {
        this.saveChangeConfirm();
      } else {
        this.showSpinnerSend = true;
        let arraySchedule = [];

        let arraySend = this.listCalendar.filter((currentValue) => {
          return currentValue.request;
        });

        arraySend.forEach((element) => {
          let json = {
            StartDate: this.$moment(element.StartDate).format(
              this.formatDateSchedule
            ),
            EndDate: this.$moment(element.EndDate).format(
              this.formatDateSchedule
            ),
            StateClassId: parseInt(Constants.CALENDAR_STATUS.CONFIRM.VALUE),
            IsNew: element.isNew,
            NoRecurrent:
              element.noRecurrent === undefined || element.noRecurrent === false
                ? false
                : true,
          };
          arraySchedule.push(json);
        });
        let arrayDelete = this.listClassDelete.map((item) => {
          return {
            ...item,
            StartDate: this.$moment(item.startDate).format(
              this.formatDateSchedule
            ),
            EndDate: this.$moment(item.endDate).format(this.formatDateSchedule),
            StateClassId: parseInt(Constants.CALENDAR_STATUS.CONFIRM.VALUE),
          };
        });
        this.SelectBeginningDateEdit = new Date();
        let jsonData = {
          ScheduleCounter: {
            id: this.GroupScheduleCounterProposalId,
            BeginningDate: this.SelectBeginningDateEdit,
          },
          ScheduleCounterDetail: arraySchedule.concat(
            arrayDelete.filter(
              (item) =>
                item.id > 0 &&
                (item.isNew === undefined || item.isNew === false)
            )
          ),
          UserMail: this.$store.state.user.email,
        };

        convertTimeCalendarEvents(
          jsonData.ScheduleCounterDetail,
          this.$store.state.user.timeZoneName,
          this.$moment
        );
        if (this.GroupScheduleCounterProposalId != 0) {
          let flagContinue = await this.validateScheduleCounterProposal(
            this.GroupScheduleCounterProposalId
          );
          if (!flagContinue) {
            return;
          }
        }
        jsonData.TimeZoneName = this.$store.state.user.timeZoneName;
        baseInstanceAxios
          .post(
            `${this.apiURL}/resources/GroupScheduleCounterProposal/ValidateSaveEditionScheduleCounterByTimeExceed`,
            jsonData
          )
          .then((response) => {
            this.showSpinnerSend = false;
            this.showLoadingCalendar = false;
            if (response.data.entity != null) {
              this.listResult = response.data.entity.scheduleCounterDetail;
              if (this.listResult.length > 0) {
                this.calendarOptions.events.forEach((event) => {
                  if (event.editable && !(event.noRecurrent === false)) {
                    let isInList = this.listResult.find(
                      (item) =>
                        item.startDate === event.start &&
                        item.endDate === event.end
                    );
                    event.isInList = isInList != undefined;
                  } else {
                    event.isInList = false;
                  }
                });
              }
            } else {
              this.saveChangeValidar();
            }
          })
          .catch((error) => {
            this.message = this.$t("error.error-saving-changes");
            this.$bvToast.show("toast-equis-modal-calendar-class-edit");
            this.showSpinnerSend = false;
          });
      }
    },
    async saveChangeValidar() {
      this.showSpinnerSend = true;
      let arraySchedule = [];

      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request;
      });

      arraySend.forEach((element) => {
        let json = {
          StartDate: this.$moment(element.StartDate).format(
            this.formatDateSchedule
          ),
          EndDate: this.$moment(element.EndDate).format(
            this.formatDateSchedule
          ),
          StateClassId: parseInt(Constants.CALENDAR_STATUS.CONFIRM.VALUE),
          IsNew: element.isNew,
          NoRecurrent:
            element.noRecurrent === undefined || element.noRecurrent === false
              ? false
              : true,
        };
        arraySchedule.push(json);
      });
      let arrayDelete = this.listClassDelete.map((item) => {
        return {
          ...item,
          StartDate: this.$moment(item.startDate).format(
            this.formatDateSchedule
          ),
          EndDate: this.$moment(item.endDate).format(this.formatDateSchedule),
          StateClassId: parseInt(Constants.CALENDAR_STATUS.CONFIRM.VALUE),
        };
      });
      this.SelectBeginningDateEdit = new Date();
      let jsonData = {
        ScheduleCounter: {
          id: this.GroupScheduleCounterProposalId,
          BeginningDate: this.SelectBeginningDateEdit,
        },
        ScheduleCounterDetail: arraySchedule.concat(
          arrayDelete.filter(
            (item) =>
              item.id > 0 && (item.isNew === undefined || item.isNew === false)
          )
        ),
        UserMail: this.$store.state.user.email,
      };

      convertTimeCalendarEvents(
        jsonData.ScheduleCounterDetail,
        this.$store.state.user.timeZoneName,
        this.$moment
      );
      if (this.GroupScheduleCounterProposalId != 0) {
        let flagContinue = await this.validateScheduleCounterProposal(
          this.GroupScheduleCounterProposalId
        );
        if (!flagContinue) {
          return;
        }
      }
      baseInstanceAxios
        .post(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/ValidateSaveEditionScheduleCounter`,
          jsonData
        )
        .then((response) => {
          this.showSpinnerSend = false;
          this.showLoadingCalendar = false;
          if (response.data != null) {
            if (
              response.data.valueDecimal == 0 &&
              response.data.return == false
            ) {
              this.$bvModal.show("modal-validate-cross-edit");
              this.$bvModal.hide("modal-save-change-edit");
            } else {
              if (response.data.valueDecimal > 0) {
                this.message = this.$t("reusables.student-edited-schedule-14", {
                  NRO: response.data.valueDecimal.toString(),
                });
                this.$bvModal.show(
                  "modal-validate-save-change-counter-student-edit"
                );
              } else {
                this.saveChangeConfirm();
              }
            }
          }
        })
        .catch((error) => {
          this.message = this.$t("error.error-saving-changes");
          this.$bvToast.show("toast-equis-modal-calendar-class-edit");
          this.showSpinnerSend = false;
        });
    },
    async saveChangeConfirm() {
      this.showLoadingCalendar = true;
      this.$bvModal.hide("modal-validate-save-change-counter-student-edit");

      this.showSpinnerSend = true;
      let arraySchedule = [];

      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request;
      });

      if (this.flagPlanTest) {
        this.SelectBeginningDate = arraySend[0].StartDate;
      }
      arraySend.forEach((element) => {
        let json = {
          StartDate: this.$moment(element.StartDate).format(
            this.formatDateSchedule
          ),
          EndDate: this.$moment(element.EndDate).format(
            this.formatDateSchedule
          ),
          StateClassId: parseInt(Constants.CALENDAR_STATUS.CONFIRM.VALUE),
          IsNew: element.isNew,
          NoRecurrent:
            element.noRecurrent === undefined || element.noRecurrent === false
              ? false
              : true,
        };
        arraySchedule.push(json);
      });
      let arrayDelete = this.listClassDelete.map((item) => {
        return {
          ...item,
          StartDate: this.$moment(item.startDate).format(
            this.formatDateSchedule
          ),
          EndDate: this.$moment(item.endDate).format(this.formatDateSchedule),
          StateClassId: parseInt(Constants.CALENDAR_STATUS.CONFIRM.VALUE),
        };
      });
      this.SelectBeginningDateEdit = new Date();
      let jsonData = {
        ScheduleCounter: {
          id: this.GroupScheduleCounterProposalId,
          BeginningDate: this.SelectBeginningDateEdit,
        },
        ScheduleCounterDetail: arraySchedule.concat(
          arrayDelete.filter(
            (item) =>
              item.id > 0 && (item.isNew === undefined || item.isNew === false)
          )
        ),
        UserMail: this.$store.state.user.email,
      };

      convertTimeCalendarEvents(
        jsonData.ScheduleCounterDetail,
        this.$store.state.user.timeZoneName,
        this.$moment
      );
      if (this.GroupScheduleCounterProposalId != 0) {
        let flagContinue = await this.validateScheduleCounterProposal(
          this.GroupScheduleCounterProposalId
        );
        if (!flagContinue) {
          return;
        }
      }
      baseInstanceAxios
        .post(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/SaveEditionScheduleCounter`,
          jsonData
        )
        .then((response) => {
          let value = response.data.value;

          if (value == -3) {
            this.message = this.$t("reusables.student-edited-schedule-15");
            this.$bvToast.show("toast-equis-modal-request-class-nav-student");
          } else if (value == -2 || value == 0) {
            this.message = this.$t("reusables.empty-filtered-text");
            this.$bvToast.show("toast-equis-modal-request-class-nav-student");
          } else if (value > 0) {
            this.message = this.$t("valid.changes-saved-correctly");
            this.$bvModal.hide("modal-save-change-edit");
            this.$bvModal.show("modal-save-change-counter-send-student-edit");
            if (this.$store.state.user != null) {
              this.$store.state.user.isResponseReceived = false;
              this.$store.commit("mutateUser", this.$store.state.user);
            }
            this.reply();
          }
          this.showSpinnerSend = false;
          this.showLoadingCalendar = false;
        })
        .catch((error) => {
          this.message = this.$t("error.error-saving-changes");
          this.$bvToast.show("toast-equis-modal-calendar-class-edit");
          this.showSpinnerSend = false;
        });
    },
    saveChangeDelete() {
      this.showSpinnerSend = true;
      let arrayDelete = this.listClassDelete.map((item) => {
        return {
          id: item.id,
          isDelete: item.isDelete,
        };
      });
      let jsonData = {
        ScheduleCounter: {
          id: 0,
        },
        ScheduleCounterDetail: arrayDelete.filter(
          (item) =>
            item.id > 0 && (item.isNew === undefined || item.isNew === false)
        ),
        UserMail: this.$store.state.user.email,
      };
      baseInstanceAxios
        .post(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/SaveEditionScheduleCounter`,
          jsonData
        )
        .then((response) => {
          this.message = this.$t("valid.changes-saved-correctly");
          this.$bvToast.show("toast-check-modal-calendar-class-edit");
          this.showSpinnerSend = false;
          this.flagCancelClass = false;
          this.showLoadingCalendar = true;
          this.reply();
        })
        .catch((error) => {
          this.message = this.$t("error.error-saving-changes");
          this.$bvToast.show("toast-equis-modal-calendar-class-edit");
          this.flagCancelClass = false;
          this.showSpinnerSend = false;
        });
    },
    async validateScheduleCounterProposal(groupScheduleCounterProposalId) {
      let flagContinue = false;
      let flagType = false; //parametro para validar la solicitud y no la propuesta o contrapropuesta
      let params = { groupScheduleCounterProposalId, flagType };

      await baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/ValidateScheduleCounterProposalStudentByActive`,
          { params }
        )
        .then((response) => {
          flagContinue = response.data.return;
          if (!response.data.return) {
            let entity = response.data.entity;

            if (entity.flagProposalAcepted) {
              this.messageValidate = this.$t(
                "reusables.student-edited-schedule-11"
              ); //GH => Cambiar
              this.typeResponseEvent = 1;
            } else {
              let objectStatus =
                Constants.STATUS_VALIDATION_COUNTER_PROPOSAL[entity.typeResult];
              if (objectStatus)
                this.messageValidate =
                  this.lang == "es" ? objectStatus.ES : objectStatus.EN;

              if (!entity.flagCount) {
                this.typeResponseEvent = 1;
              }
            }
            this.$bvModal.show("modal-conflict-validate");
          }
        });
      return flagContinue;
    },
    handleDateSelect(selectInfo) {
      this.messageAddClass = "";
      let now = new Date();
      let expirationDate = new Date(this.groupsPlan.expirationDate);
      let startRange = new Date(this.calendarOptions.validRange.start);
      let endRange = new Date(this.calendarOptions.validRange.end);

      if (selectInfo.start < now) {
        this.messageAddClass = this.$t("reusables.student-edited-schedule-12");
        this.$bvModal.show("modal-validate-register-class-edit");
        return;
      } else if (selectInfo.start < startRange || selectInfo.end > endRange) {
        this.messageAddClass = this.messageAddClass = this.$t(
          "reusables.student-edited-schedule-13"
        );
        this.$bvModal.show("modal-validate-register-class-edit");
        return;
      } else if (selectInfo.start > expirationDate) {
        this.messageAddClass = this.messageAddClass = this.$t(
          "reusables.student-edited-schedule-13"
        );
        this.$bvModal.show("modal-validate-register-class-edit");
        return;
      } else {
        this.eventCreated = selectInfo;
        if (this.flagPlanTest) {
          this.$bvModal.show("modal-add-class-plan-test");
        } else {
          this.$bvModal.show("modal-add-class-edit");
        }
      }
    },
    handleEvents(events) {
      let newEvents = events.event;
      let oldEvent = events.oldEvent;

      let fechaInicio = newEvents.startStr;
      let fechaFin = newEvents.endStr;

      let eventCurrent = this.calendarOptions.events.find(function (e) {
        return (
          new Date(e.start).getTime() ==
            new Date(oldEvent.startStr).getTime() &&
          new Date(e.end).getTime() == new Date(oldEvent.endStr).getTime() &&
          e.request === true
        );
      });
      let noRecurrent = eventCurrent.noRecurrent;
      let dateSelectStart = new Date(fechaInicio);
      let dateSelectEnd = new Date(fechaFin);
      let dateEnd = null;

      let dateAfter = new Date(
        dateSelectStart.setMinutes(
          dateSelectStart.getMinutes() + this.maximoHorasCalendario * 60
        )
      );
      if (dateSelectEnd.getTime() < dateAfter.getTime()) {
        dateEnd = dateSelectEnd;
      } else {
        dateEnd = dateAfter;
      }

      if (noRecurrent) {
        this.listCalendar = this.listCalendar.filter(function (e) {
          return (
            new Date(e.StartDate).getTime() !==
              new Date(oldEvent.startStr).getTime() &&
            new Date(e.EndDate).getTime() !==
              new Date(oldEvent.endStr).getTime()
          );
        });

        this.calendarOptions.events = this.calendarOptions.events.filter(
          function (e) {
            return (
              new Date(e.start).getTime() !==
                new Date(oldEvent.startStr).getTime() &&
              new Date(e.end).getTime() !== new Date(oldEvent.endStr).getTime()
            );
          }
        );
      } else {
        const eventDayOfWeek = new Date(oldEvent.startStr).getDay();
        const eventTimeStart = oldEvent.startStr.slice(11, 16);
        const eventTimeEnd = oldEvent.endStr.slice(11, 16);
        const eventDate = new Date(oldEvent.startStr);
        this.arrayCalendarChange = this.arrayCalendarChange.filter((e) => {
          const eventStartDate = new Date(e.StartDate);
          return !(
            eventStartDate.getDay() === eventDayOfWeek &&
            e.StartDate.slice(11, 16) === eventTimeStart &&
            e.EndDate.slice(11, 16) === eventTimeEnd &&
            e.noRecurrent === false &&
            e.request === true &&
            eventStartDate >= eventDate
          );
        });

        this.listCalendar = this.listCalendar.filter((e) => {
          const eventStartDate = new Date(e.StartDate);
          return !(
            eventStartDate.getDay() === eventDayOfWeek &&
            e.StartDate.slice(11, 16) === eventTimeStart &&
            e.EndDate.slice(11, 16) === eventTimeEnd &&
            e.noRecurrent === false &&
            e.request === true &&
            eventStartDate >= eventDate
          );
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(
          (e) => {
            const eventStartDate = new Date(e.start);
            return !(
              eventStartDate.getDay() === eventDayOfWeek &&
              e.start.slice(11, 16) === eventTimeStart &&
              e.end.slice(11, 16) === eventTimeEnd &&
              e.noRecurrent === false &&
              e.request === true &&
              eventStartDate >= eventDate
            );
          }
        );

        // eliminar el anterior
        this.listCalendar = this.listCalendar.filter(function (e) {
          return (
            new Date(e.StartDate).getTime() !==
              new Date(oldEvent.startStr).getTime() &&
            new Date(e.EndDate).getTime() !==
              new Date(oldEvent.endStr).getTime()
          );
        });

        this.calendarOptions.events = this.calendarOptions.events.filter(
          function (e) {
            return (
              new Date(e.start).getTime() !==
                new Date(oldEvent.startStr).getTime() &&
              new Date(e.end).getTime() !== new Date(oldEvent.endStr).getTime()
            );
          }
        );
      }
      events.event.remove();

      let _eventItemMerge = ValidarMergeHorariosByRecurrent(
        this.calendarOptions.events,
        fechaInicio,
        fechaFin,
        this.$moment,
        noRecurrent
      );
      let p_idEvent = createEventId();
      if (Object.keys(_eventItemMerge).length !== 0) {
        this.arrayCalendarChange.forEach((obj, i) => {
          if (obj.id == _eventItemMerge.idx) {
            obj.StartDate = this.$moment(_eventItemMerge.start).format(
              this.formatDateSchedule
            );
            obj.EndDate = this.$moment(_eventItemMerge.end).format(
              this.formatDateSchedule
            );
          }
        });

        this.listCalendar.forEach((obj, i) => {
          if (
            obj.idx ==
            (_eventItemMerge.idx == 0
              ? _eventItemMerge.id
              : parseInt(_eventItemMerge.idx, 10))
          ) {
            obj.StartDate = this.$moment(_eventItemMerge.start).format(
              this.formatDateSchedule
            );
            obj.EndDate = this.$moment(_eventItemMerge.end).format(
              this.formatDateSchedule
            );
          }
        });
      } else {
        let idx = this.obtenerCalendarId();

        let data2 = {
          id: idx,
          StartDate: this.$moment(fechaInicio).format(this.formatDateSchedule),
          EndDate: this.$moment(dateEnd).format(this.formatDateSchedule),
          StateClass: Constants.CALENDAR_STATUS.CONFIRM.VALUE,
          request: true,
          editable: true,
          noRecurrent: noRecurrent,
          isNew: true,
          flagPlantTest: false,
        };

        this.listCalendar.push(data2);

        this.calendarOptions.events.push({
          idx: idx,
          id: p_idEvent, //createEventId(),
          start: this.$moment(fechaInicio).format(this.formatDateSchedule),
          end: this.$moment(dateEnd).format(this.formatDateSchedule),
          title: this.$t("horario.calendario.label-calendar-teacher", {
            TeacherName: this.dataTeacher.firstName,
          }),
          editable: true,
          request: true,
          color: noRecurrent
            ? Constants.CALENDAR_STATUS_ADDITIONAL_COLOR.NORECURRENT
            : Constants.CALENDAR_STATUS.CONFIRM.COLOR,
          noRecurrent: noRecurrent,
          isNew: true,
          isInList: false,
        });
      }

      if (!noRecurrent) {
        let replicatedStartDate = new Date(fechaInicio);
        const expirationDate = new Date(this.groupsPlan.expirationDate);

        while (replicatedStartDate < expirationDate) {
          replicatedStartDate.setDate(replicatedStartDate.getDate() + 7);
          dateEnd.setDate(dateEnd.getDate() + 7);

          let _eventItemMerge = ValidarMergeHorariosByRecurrent(
            this.calendarOptions.events,
            replicatedStartDate.toISOString(),
            dateEnd.toISOString(),
            this.$moment,
            false
          );

          if (Object.keys(_eventItemMerge).length !== 0) {
            this.JoinEvent(_eventItemMerge);
          } else {
            let newIdx = this.obtenerCalendarId();
            this.AddNewEvent(
              newIdx,
              p_idEvent,
              replicatedStartDate,
              dateEnd,
              false
            );
          }
        }
      }
    },

    SaveClassRegister() {
      this.$v.classRegister.$touch();
      if (this.$v.classRegister.$invalid) {
        return;
      } else {
        this.idValueSelectEventSelectedTimeClassRegister(this.eventCreated);
        let fechaInicio = this.eventCreated.startStr;
        let fechaFin = this.eventCreated.endStr;

        let idx = this.obtenerCalendarId();
        let _id = createEventId();
        let dateSelectStart = new Date(fechaInicio);
        let dateSelectEnd = new Date(fechaFin);
        let dateEnd;

        let noRecurrent = this.classRegister.typeClass === "true";

        let dateAfter = new Date(dateSelectStart);
        dateAfter.setMinutes(
          dateAfter.getMinutes() + this.maximoHorasCalendario * 60
        );
        dateEnd =
          dateSelectEnd.getTime() < dateAfter.getTime()
            ? dateSelectEnd
            : dateAfter;

        let num = this.ObtenerRangoFecha(
          fechaInicio,
          dateEnd.toISOString(),
          this.listCalendar
        );
        if (num === 0) {
          let replicatedStartDate = new Date(fechaInicio);
          const expirationDate = new Date(this.groupsPlan.expirationDate);

          let _eventItemMerge = ValidarMergeHorariosByRecurrent(
            this.calendarOptions.events,
            replicatedStartDate.toISOString(),
            dateEnd.toISOString(),
            this.$moment,
            noRecurrent
          );

          if (Object.keys(_eventItemMerge).length !== 0) {
            this.JoinEvent(_eventItemMerge);
          } else {
            this.AddNewEvent(
              idx,
              _id,
              replicatedStartDate,
              dateEnd,
              noRecurrent
            );
          }

          if (noRecurrent) {
            this.flagChange = true;
            this.FinishSaved();
            return;
          }
          while (replicatedStartDate < expirationDate) {
            replicatedStartDate.setDate(replicatedStartDate.getDate() + 7);
            dateEnd.setDate(dateEnd.getDate() + 7);

            let _eventItemMerge = ValidarMergeHorariosByRecurrent(
              this.calendarOptions.events,
              replicatedStartDate.toISOString(),
              dateEnd.toISOString(),
              this.$moment,
              false
            );

            if (Object.keys(_eventItemMerge).length !== 0) {
              this.JoinEvent(_eventItemMerge);
            } else {
              let newIdx = this.obtenerCalendarId();
              this.AddNewEvent(
                newIdx,
                _id,
                replicatedStartDate,
                dateEnd,
                false
              );
            }
          }
          this.flagChange = true;
          this.FinishSaved();
        } else {
          this.message = `${this.$t(
            "modals.modalViewSchedule.maximoHorasCalendario.1"
          )} ${this.maximoHorasCalendario * 60} ${this.$t(
            "modals.modalViewSchedule.maximoHorasCalendario.2"
          )}`;
          this.$bvToast.show("toast-equis-modal-calendar-class-edit");
        }
      }
    },
    JoinEvent(eventItemMerge) {
      this.arrayCalendarChange.forEach((obj) => {
        if (obj.id === eventItemMerge.idx) {
          obj.StartDate = this.$moment(eventItemMerge.start).format(
            this.formatDateSchedule
          );
          obj.EndDate = this.$moment(eventItemMerge.end).format(
            this.formatDateSchedule
          );
        }
      });

      this.listCalendar.forEach((obj) => {
        if (
          obj.idx ===
          (eventItemMerge.idx === 0
            ? eventItemMerge.id
            : parseInt(eventItemMerge.idx, 10))
        ) {
          obj.StartDate = this.$moment(eventItemMerge.start).format(
            this.formatDateSchedule
          );
          obj.EndDate = this.$moment(eventItemMerge.end).format(
            this.formatDateSchedule
          );
        }
      });
    },

    AddNewEvent(idx, _id, start, end, noRecurrent) {
      let eventData = {
        id: idx,
        StartDate: this.$moment(start).format(this.formatDateSchedule),
        EndDate: this.$moment(end).format(this.formatDateSchedule),
        StateClass: Constants.CALENDAR_STATUS.CONFIRM.VALUE,
        request: true,
        editable: true,
        noRecurrent: noRecurrent,
        isNew: true,
      };

      this.arrayCalendarChange.push(eventData);
      this.listCalendar.push(eventData);

      this.calendarOptions.events.push({
        idx: idx,
        id: _id,
        description: "",
        start: this.$moment(start).format(this.formatDateSchedule),
        end: this.$moment(end).format(this.formatDateSchedule),
        title: this.$t("horario.calendario.label-calendar-teacher", {
          TeacherName: this.dataTeacher.firstName,
        }),
        editable: true,
        request: true,
        color: noRecurrent
          ? Constants.CALENDAR_STATUS_ADDITIONAL_COLOR.NORECURRENT
          : Constants.CALENDAR_STATUS.CONFIRM.COLOR,
        noRecurrent: noRecurrent,
        isNew: true,
        isInList: false,
      });
    },
    FinishSaved() {
      this.disabledDate = false;
      this.getDateMinMax(new Date());
      this.$bvModal.hide("modal-add-class-edit");

      if (this.classRegister.typeClass === "true") {
        this.classRegister.idx = createEventId();
        this.listClassRegister.push(this.classRegister);
      }

      this.classRegister = {
        id: "",
        typeClass: null,
        timeClass: null,
        startDate: null,
        endDate: null,
        noRecurrent: false,
        isNew: false,
      };

      this.$bvModal.hide("modal-add-class-edit");
      this.$v.classRegister.$reset();
    },
    showModalEditarHorario() {
      this.listResult = [];
      this.calendarOptions.events.forEach((event) => {
        event.isInList = false;
      });
      if (
        this.flagChange == false &&
        this.listClassDelete.filter(
          (item) =>
            item.id > 0 && (item.isNew === undefined || item.isNew === false)
        ).length > 0
      ) {
        this.flagCancelClass = true;
        this.saveChangeDelete();
      } else {
        this.SelectBeginningDateEdit = "";
        this.$v.$reset();
        this.listRecurrent = [];
        this.listRecurrent = this.groupedEvents();
        this.$bvModal.show("modal-save-change-edit");
      }
    },
    validateChanges() {
      let elmts = [];
      let arrayCalendar = [];
      let arrayCalendarInit = [];
      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request;
      });
      let arraySendInit = this.arrayCalendarInit.filter((currentValue) => {
        return currentValue.request;
      });

      arraySend.forEach((element) => {
        arrayCalendar.push(
          `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
        );
      });
      arraySendInit.forEach((element) => {
        arrayCalendarInit.push(
          `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
        );
      });

      if (arrayCalendar.length > arrayCalendarInit.length) {
        elmts = arrayCalendar.filter(function (i) {
          return this.indexOf(i) < 0;
        }, arrayCalendarInit);
      } else {
        elmts = arrayCalendarInit.filter(function (i) {
          return this.indexOf(i) < 0;
        }, arrayCalendar);
      }
      if (arraySend.length == 0) {
        return true;
      } else {
        return elmts.length == 0 ? true : false;
      }
    },
    obtenerCalendarId() {
      let idx = 0;
      let dataTmp = this.listCalendar;

      let ultId =
        dataTmp.length == 0 ? 1 * -1000 : dataTmp[dataTmp.length - 1].id;
      ultId = ultId == null ? 0 : ultId;
      idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;

      return idx;
    },
    getNotSchedulecrossing() {
      let arraySend = this.listCalendar.filter((currentValue) => {
        return currentValue.request;
      });

      let sum = 0;
      arraySend.forEach((element) => {
        let result = this.ObtenerRangoFechaDisable(
          element.StartDate,
          element.EndDate,
          this.hourPlanTest
        );

        sum = sum + result;
      });

      if (sum == 0) {
        this.disabledDate = true;
      }
    },

    getListHours() {
      this.flagDeleteEvent = false;
      this.arraySchedulePrivate = [];
      this.disabledButtons = false;
      this.hourDisbaled = [];
      this.listCalendar = [];
      this.calendarOptions.events = [];
      this.hourTotal = 0;
      this.editHourTotal = 0;
      this.showLoading = true;
      let json = {
        GroupScheduleProposalCustomId: this.GroupScheduleCounterProposalId,
        PersonTeacherId: this.$store.state.user.personTeacherId,
        TimeZoneName: this.$store.state.user.timeZoneName,
      };

      baseInstanceAxios
        .post(
          _ctx + "/resources/GroupsCoursesLessons/ListScheduleTeacherByStudent",
          json
        )
        .then((response) => {
          if (response.data) {
            let typeProposalId = response.data.entity.schedule.flagTypeProposal;

            let arrayHoursTmp = response.data.entity.scheduleDetail;
            let arrayHoursConvert = convertToUserTimeCalendarEvents(
              arrayHoursTmp.filter((item) => {
                return (
                  item.typeOfSchedule ==
                    Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST ||
                  item.typeOfSchedule ==
                    Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE
                );
              }),
              this.$store.state.user.timeZoneName,
              this.$moment
            );

            let arrayHours = arrayHoursTmp
              .filter((item) => {
                return !(
                  item.typeOfSchedule ==
                    Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST ||
                  item.typeOfSchedule ==
                    Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE
                );
              })
              .concat(arrayHoursConvert);
            //let arrayHours = response.data.entity.scheduleDetail;

            this.SelectBeginningDate =
              response.data.entity.schedule.beginningDate;
            this.SelectBeginningDateInit =
              response.data.entity.schedule.beginningDate;
            let dataList = [];
            let id = 0;
            this.hourDisbaled = arrayHours.filter((valueCurrent) => {
              return (
                valueCurrent.typeOfSchedule ==
                  Constants.TYPE_OF_SCHEDULE.SCHEDULE_CLASSES_TEACHER ||
                valueCurrent.typeOfSchedule ==
                  Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE
              );
            });

            this.hourPlanTest = this.hourDisbaled.filter((valueCurrent) => {
              return valueCurrent.flagPlanTest;
            });

            this.hourEnabled = arrayHours.filter((valueCurrent) => {
              return (
                valueCurrent.typeOfSchedule ==
                  Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST ||
                valueCurrent.typeOfSchedule ==
                  Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE
              );
            });

            arrayHours.forEach((element) => {
              let colorResquest = "";
              let titleClass = "";
              if (
                Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST ==
                  element.typeOfSchedule ||
                Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE ==
                  element.typeOfSchedule
              ) {
                let startOfWeek = this.$moment(element.startDate)
                  .startOf("week")
                  .toDate();
                let startOfWeekCurrent = this.$moment()
                  .startOf("week")
                  .toDate();
                let diff = this.$moment(startOfWeekCurrent).diff(
                  this.$moment(startOfWeek),
                  "days"
                );
                if (diff < -7) {
                  diff = 0;
                }
                this.dateStudent = this.$moment(element.startDate).add(
                  diff,
                  "d"
                );
                let dateInitData = this.$moment(element.startDate).add(
                  diff,
                  "d"
                );
                let dateEndData = this.$moment(element.endDate).add(diff, "d");
                if (!typeProposalId) {
                  titleClass = "Class";
                  if (element.flagPlanTest) {
                    titleClass = this.$t("reusables.test-class"); //"Clase de prueba";
                  }
                  //agregar nombre del estudiante
                  titleClass = titleClass + " - " + element.className;
                } else {
                  titleClass = this.$t("reusables.teacher");
                }

                let resultCruce = this.ObtenerRangoFechaDisable(
                  this.$moment(dateInitData).format("YYYY-MM-DDTHH:mm:ss"),
                  this.$moment(dateEndData).format("YYYY-MM-DDTHH:mm:ss"),
                  this.hourDisbaled
                );

                colorResquest = Constants.CALENDAR_STATUS.COMPLETED.COLOR;
                if (resultCruce != 0) {
                  colorResquest = "#cc0000"; //color clase con conflicto
                }

                this.arrayEditableSchedule.push(id);
                let startDate = new Date(element.startDate);
                let endDate = new Date(element.endDate);
                let seconds =
                  (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60);

                this.hourTotal += seconds;
                this.editHourTotal += seconds;

                let jsonData = {
                  id: createEventId(),
                  title: titleClass,
                  description: "",
                  idx: id,
                  start: this.$moment(dateInitData).format(
                    "YYYY-MM-DDTHH:mm:ss"
                  ),
                  end: this.$moment(dateEndData).format("YYYY-MM-DDTHH:mm:ss"),
                  color: colorResquest,
                  editable: false,
                  className: resultCruce != 0 ? "cruce" : "",
                };

                let data = {
                  id: id,
                  StartDate: this.$moment(dateInitData).format(
                    "YYYY-MM-DDTHH:mm:ss"
                  ),
                  EndDate: this.$moment(dateEndData).format(
                    "YYYY-MM-DDTHH:mm:ss"
                  ),
                  request: element.id != 0 ? true : false,
                  flagPlantTest: element.flagPlanTest,
                  className: resultCruce != 0 ? "cruce" : "",
                };

                dataList.push(jsonData);
                this.listCalendar.push(data);
              }
              if (
                Constants.TYPE_OF_SCHEDULE.SCHEDULE_CLASSES_TEACHER ==
                element.typeOfSchedule
              ) {
                //colorResquest = "#03c2fc";

                let className = this.lang == "en" ? "Class" : "Clases";
                for (let index = 0; index <= 7; index = index + 7) {
                  let dateInitData = this.$moment(
                    new Date(element.startDate)
                  ).add(index, "d");
                  let dateEndData = this.$moment(new Date(element.endDate)).add(
                    index,
                    "d"
                  );
                  colorResquest = Constants.CALENDAR_STATUS.PENDIENT.COLOR;
                  titleClass =
                    element.className != null
                      ? `${className} - ${element.className}`
                      : className;
                  if (element.flagPlanTest) {
                    titleClass = this.$t("reusables.test-class"); //"Clase de prueba";
                  }

                  let jsonData = {
                    id: createEventId(),
                    title: titleClass,
                    description: "",
                    idx: id,
                    start: this.$moment(dateInitData).format(
                      "YYYY-MM-DDTHH:mm:ss"
                    ),
                    end: this.$moment(dateEndData).format(
                      "YYYY-MM-DDTHH:mm:ss"
                    ),
                    color: colorResquest,
                    editable: false,
                  };

                  let data = {
                    id: id,
                    StartDate: this.$moment(dateInitData).format(
                      "YYYY-MM-DDTHH:mm:ss"
                    ),
                    EndDate: this.$moment(dateEndData).format(
                      "YYYY-MM-DDTHH:mm:ss"
                    ),
                    request: element.id != 0 ? true : false,
                    flagPlantTest: element.flagPlanTest,
                  };
                  dataList.push(jsonData);
                  this.listCalendar.push(data);
                }
              }
              if (
                Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE ==
                element.typeOfSchedule
              ) {
                for (let index = 0; index <= 7; index = index + 7) {
                  let dateInitData = this.$moment(
                    new Date(element.startDate)
                  ).add(index, "d");
                  let dateEndData = this.$moment(new Date(element.endDate)).add(
                    index,
                    "d"
                  );
                  colorResquest = Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR;
                  titleClass = this.$t("reusables.unavailable");

                  let jsonData = {
                    id: createEventId(),
                    title: titleClass,
                    description: "",
                    idx: id,
                    start: this.$moment(dateInitData).format(
                      "YYYY-MM-DDTHH:mm:ss"
                    ),
                    end: this.$moment(dateEndData).format(
                      "YYYY-MM-DDTHH:mm:ss"
                    ),
                    color: colorResquest,
                    editable: false,
                  };

                  let data = {
                    id: id,
                    StartDate: this.$moment(dateInitData).format(
                      "YYYY-MM-DDTHH:mm:ss"
                    ),
                    EndDate: this.$moment(dateEndData).format(
                      "YYYY-MM-DDTHH:mm:ss"
                    ),
                    request: element.id != 0 ? true : false,
                    flagPlantTest: element.flagPlanTest,
                  };
                  dataList.push(jsonData);
                  this.listCalendar.push(data);
                }

                //titleClass = "No disponible"
              }
              id++;
            });

            this.calendarOptions.events = dataList;

            this.calendarOptions.selectable = false;
            this.showLoading = false;
            this.disabledButtons = true;
            setTimeout(() => {
              if (arrayHours.length > 0) {
                let d = new Date(this.dateStudent);
                let startOfWeek = this.$moment(d).startOf("week").toDate();

                let month =
                  parseInt(new Date(startOfWeek).getMonth()) + 1 < 10
                    ? `0${parseInt(new Date(startOfWeek).getMonth()) + 1}`
                    : parseInt(new Date(startOfWeek).getMonth()) + 1;
                let dayDate =
                  parseInt(new Date(startOfWeek).getDate()) < 10
                    ? `0${parseInt(new Date(startOfWeek).getDate())}`
                    : parseInt(parseInt(new Date(startOfWeek).getDate()));

                let calendarApi = this.$refs.fullCalendar.getApi();
                calendarApi.gotoDate(
                  this.$moment(startOfWeek).format("YYYY") +
                    "-" +
                    month +
                    "-" +
                    dayDate
                );
              }
            }, 1000);
          }
        })
        .catch((err) => {
          console.log("err : ", err);
        });
    },

    ObtenerRangoFecha(StartDate, EndDate, listCalendar) {
      var result = listCalendar.filter((e) => {
        return (
          (!(
            new Date(StartDate).getTime() == new Date(e.StartDate).getTime()
          ) &&
            new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(StartDate).getTime() < new Date(e.EndDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() > new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() == new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime())
        );
      });
      return result.length;
    },

    ObtenerRangoFechaDisable(StartDate, EndDate, listCalendar) {
      var result = listCalendar.filter((e) => {
        if (
          (!(
            new Date(StartDate).getTime() == new Date(e.startDate).getTime()
          ) &&
            new Date(StartDate).getTime() <= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.startDate).getTime() &&
            new Date(StartDate).getTime() < new Date(e.endDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() > new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() == new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.endDate).getTime())
        ) {
          if (!this.dataStudent.flagPlanTest) {
            if (e.flagPlanTest) {
              this.disabledDate = false;
              let num = 7;
              this.minDate = new Date(e.startDate);
              this.minDate.setDate(this.minDate.getDate() + 1);
              let d = new Date(e.startDate),
                diff = d.getDate() + num;
              this.maxDate = new Date(d.setDate(diff));
            }
          }
        }

        return (
          (!(
            new Date(StartDate).getTime() == new Date(e.startDate).getTime()
          ) &&
            new Date(StartDate).getTime() <= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.startDate).getTime() &&
            new Date(StartDate).getTime() < new Date(e.endDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() > new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() == new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.endDate).getTime())
        );
      });
      return result.length;
    },
    getCalendarHeaderToolbarTestClass(flagShowHeader) {
      if (flagShowHeader) {
        return {
          left: "",
          center: "title",
          right: "",
        };
      }

      return {
        left: "",
        center: "",
        right: "",
      };
    },
    showTeacherInfoComment(id) {
      this.$emit("listenTeacherInfoComments", id);
    },
    async validateCounterProposal(groupScheduleCounterProposalId) {
      let flagContinue = false;
      let flagType = false; //parametro para validar la solicitud y no la propuesta o contrapropuesta
      let params = {
        groupScheduleCounterProposalId,
        flagType,
      };

      await baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/ValidateCounterProposalStudentByActive`,
          {
            params,
          }
        )
        .then((response) => {
          flagContinue = response.data.return;
          if (!response.data.return) {
            let entity = response.data.entity;

            if (entity.flagProposalAcepted) {
              this.messageValidate = this.$t(
                "reusables.student-edited-schedule-11"
              ); //GH => Cambiar
              this.typeResponseEvent = 1;
            } else {
              let objectStatus =
                Constants.STATUS_VALIDATION_COUNTER_PROPOSAL[entity.typeResult];
              if (objectStatus)
                this.messageValidate =
                  this.lang == "es" ? objectStatus.ES : objectStatus.EN;

              if (entity.flagCount) {
                if (this.typeOption == 1) {
                  this.typeResponseEvent =
                    entity.countProposalMassive == 0 ? 2 : 3;
                } else {
                  this.typeResponseEvent =
                    entity.countProposalDirects == 0 ? 4 : 3;
                }
              } else {
                this.typeResponseEvent = 1;
              }
            }
            this.$bvModal.show("modal-conflict-validate");
          }
        });
      return flagContinue;
    },
    acceptProposal() {
      this.showSpinnerAccept = true;
      let data = {
        scheduleEditedId: this.groupsScheduleProposalEditedId,
        Usuario: this.$store.state.user.email,
        FlagStudent: true,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupsCoursesLessons/SaveScheduleEditedStudentSteachersDetails`,
          {
            params: data,
          }
        )
        .then((response) => {
          let value = response.data.value;
          this.showSpinnerAccept = false;
          if (value == -3) {
            this.$bvModal.hide("modal-schedule-accept-nav-student");
            this.message = this.$t("reusables.student-edited-schedule-14");
            this.$bvToast.show("toast-equis-modal-request-class-nav-student");
          } else if (value == -2) {
            this.$bvModal.hide("modal-schedule-accept-nav-student");
            this.message = this.$t("reusables.empty-filtered-text");
            this.$bvToast.show("toast-equis-modal-request-class-nav-student");
          } else if (value > 0) {
           if (this.$store.state.user != null) {
            this.$store.state.user.isResponseReceived = false;
            this.$store.commit("mutateUser", this.$store.state.user);
          }
            this.message = this.$t("modalConfirm.text.3");
            this.$bvToast.show("toast-check-modal-request-class-nav-student");
            this.showSpinnerAccept = false;
            this.$bvModal.hide("modal-schedule-accept-nav-student");
            this.$emit("updateSchedule");
            this.modalHideSchedule();
          }
        })
        .catch((error) => {
          this.message = this.$t("modalConfirm.text.6");
          this.$bvToast.show("toast-equis-modal-request-class-nav-student");
          this.showSpinnerAccept = false;
        });
    },
    rejectProposal() {
      this.showSpinnerReject = true;
      let data = {
        GroupScheduleProposalId: this.groupsScheduleProposalEditedId,
        RejectCommentary: "",
        UserMail: this.$store.state.user.email,
        FlagStudent: true,
      };

      baseInstanceAxios
        .get(
          `${this.apiURL}/resources/GroupScheduleCounterProposal/RejectEditionScheduleByTeacher`,
          {
            params: data,
          }
        )
        .then((response) => {
          this.message = this.$t("modalConfirm.text.7");
          this.$bvToast.show("toast-check-modal-request-class-nav-student");
          this.showSpinnerReject = false;
          this.$bvModal.hide("modal-schedule-reject-nav-student");
          this.$emit("updateSchedule");
          if (this.$store.state.user != null) {
            this.$store.state.user.isResponseReceived = false;
            this.$store.commit("mutateUser", this.$store.state.user);
          }
          this.modalHideSchedule();
        })
        .catch((error) => {
          this.message = this.$t("modalConfirm.text.8");
          this.$bvToast.show("toast-equis-modal-request-class-nav-student");
          this.showSpinnerReject = false;
        });
    },
    groupedEvents() {
      let grouped = {};
      let pListRecurrent = this.calendarOptions.events.filter(
        (currentValue) => {
          return currentValue.editable && !(currentValue.noRecurrent == true);
        }
      );
      pListRecurrent.forEach((event) => {
        const formattedDate = this.getFormatDateCompleteTitle(
          event.start,
          event.end
        );
        if (!grouped[formattedDate]) {
          grouped[formattedDate] = [];
        }
        grouped[formattedDate].push(event);
      });
      const dayOrder =
        localStorage.getItem("lang") == "es"
          ? this.ARRAY_DIA_SEMANA.ES
          : this.ARRAY_DIA_SEMANA.EN;

      const dayOrderIndex = dayOrder.reduce((acc, day, index) => {
        acc[day] = index;
        return acc;
      }, {});

      return Object.keys(grouped)
        .map((date) => {
          const dayName = date.split(",")[0];
          const timeRange = date.split(",")[1].trim();
          return {
            date: date,
            events: grouped[date],
            dayOrder: dayOrderIndex[dayName],
            timeRange: timeRange,
          };
        })
        .sort((a, b) => {
          if (a.dayOrder !== b.dayOrder) {
            return a.dayOrder - b.dayOrder;
          }
          return a.timeRange.localeCompare(
            b.timeRange,
            localStorage.getItem("lang") === "es" ? "es" : "en"
          );
        })
        .map((group) => {
          return {
            date: group.date,
            events: group.events,
          };
        });
    },
    groupedEventsCounter() {
      let grouped = {};
      let pListRecurrent = this.listCalendarTeacher.filter((currentValue) => {
        return currentValue.noRecurrent == false;
      });
      pListRecurrent.forEach((event) => {
        const formattedDate = this.getFormatDateCompleteTitle(
          event.StartDate,
          event.EndDate
        );
        if (!grouped[formattedDate]) {
          grouped[formattedDate] = [];
        }
        grouped[formattedDate].push(event);
      });
      const dayOrder =
        localStorage.getItem("lang") == "es"
          ? this.ARRAY_DIA_SEMANA.ES
          : this.ARRAY_DIA_SEMANA.EN;

      const dayOrderIndex = dayOrder.reduce((acc, day, index) => {
        acc[day] = index;
        return acc;
      }, {});

      return Object.keys(grouped)
        .map((date) => {
          const dayName = date.split(",")[0];
          const timeRange = date.split(",")[1].trim();
          return {
            date: date,
            events: grouped[date],
            dayOrder: dayOrderIndex[dayName],
            timeRange: timeRange,
          };
        })
        .sort((a, b) => {
          if (a.dayOrder !== b.dayOrder) {
            return a.dayOrder - b.dayOrder;
          }
          return a.timeRange.localeCompare(
            b.timeRange,
            localStorage.getItem("lang") === "es" ? "es" : "en"
          );
        })
        .map((group) => {
          return {
            date: group.date,
            events: group.events,
          };
        });
    },
  },
};
</script>

<style>
.icon-yout-disabled {
  fill: #b7b8bd !important;
  pointer-events: none !important;
}
.red-item {
  color: red;
}
</style>